export const english: any = {
  langName: 'English',
  langKey: 'en-US',
  items: {
    ACTIVE_DEMANDS_LIMIT: 'Active Demands Limit',
    ACTIVE_SUPPLIES_LIMIT: 'Active Supplies Limit',
    CEDATO: 'Cedato',
    DASHBOARD: 'Dashboard',
    CEDATO_DASHBOARD: 'Cedato Dashboard',
    WELCOME_TO_CEDATO: 'Welcome to Cedato',
    PAGE_NOT_FOUND: 'Page not found',
    LOGGED_IN_SUCCESSFULLY: 'Logged in successfully',
    LOADING_YOUR_NETWORK_DATA: "Loading your network's data...",
    SUPPLY: 'Supply',
    SUPPLIES: 'supplies',
    ALL_SUPPLY: 'All Supply Report',
    SUPPLY_BY_DEMAND: 'Supply by Demand Report',
    SUPPLY_BY_DAY: 'Supply by Day Report',
    SUPPLY_BY_DOMAIN: 'Supply by Domain Report',
    BY_DEMAND_SOURCE: 'By Demand Source',
    DEMAND: 'Demand',
    DEMANDS: 'demands',
    ALL_DEMAND: 'All Demand Report',
    EXCO_REPORT: 'EX.CO Report',
    RELEASE_DASHBOARD: 'Release Dashboard',
    NETWORKS_REPORT: 'Networks Report',
    DEMAND_BY_SUPPLY: 'Demand by Supply Report',
    DEMAND_BY_DAY: 'Demand by Day Report',
    DEMAND_BY_DOMAIN: 'Demand by Domain Report',
    BY_SUPPLY: 'By Supply',
    BY_DEMAND: 'By Demand',
    BY_DOMAIN: 'By Domain',
    BY_DEMAND_DOMAINS: 'By Demand Domains',
    BY_DAY: 'By Day',
    BY_HOUR: 'By Hour',
    BY_SUB_ID: 'By Sub-ID',
    BY_USER_AGENT: 'By User Agent',
    BY_DEMAND_AND_SUB_ID: 'By Domain and Sub-ID',
    DOMAINS: 'Domains',
    BUNDLES_DOMAINS: 'Bundles/Domains',
    URL_ADDRESSES: 'URLs',
    QUALITY_AND_VIEWABILITY: 'Quality & Viewability',
    QUALITY_AND_VIEWABILITY_REPORT: 'Quality & Viewability Report',
    LAB: 'Lab',
    CONTENT: 'Content',
    MANAGE: 'Manage',
    LIST: 'List',
    CDN: 'CDN',
    CEDATO_MARKET: 'Cedato Market',
    BILLING: 'Billing',
    PUBLISHER: 'Publisher',
    ACCOUNT_PUBLISHER: 'Account Publisher',
    CHANNEL_PUBLISHER: "Channel's Publisher",
    AGGREGATOR: 'PubDemand',
    ADMIN: 'Admin',
    RECENT: 'Recent',
    MY_REPORTS: 'My Reports',
    BROADCAST: 'Broadcast',
    NETWORKS: 'Networks',
    USERS: 'Users',
    DEBUG_TOOL: 'Debug Tool',
    ADD_BROADCAST: 'Add Broadcast',
    EDIT_BOARDCAST: 'Edit Broadcast',
    ADD_USER: 'Add User',
    EDIT_USER: 'Edit User',
    CEDATO_LABS: 'Cedato Labs V1',
    CEDATO_LABS_V2: 'Cedato Labs V2',
    MORE: 'More',
    LESS: 'Less',
    ALL: 'All',
    CREATE: 'Create',
    CHOOSE: 'Choose',
    ADD: 'Add',
    REMOVE: 'Remove',
    REMOVE_ALL: 'Remove All',
    NEW_REPORT: 'New Report',
    EMAIL_REPORT: 'Sending Report',
    EMAIL_REPORT_TEXT: 'Since the requested report is too large, it will be sent to the following email:',
    EMAIL_TIMEOUT_REPORT_TEXT: 'Creating the report takes a while. Will you prefer to receive it by mail?',
    EMAIL_TIMEOUT_CANCEL_TEXT: 'Wait for your report',
    REPORT: 'Report',
    REPORTS: 'Reports',
    PUBLISHERS: 'Publishers',
    HELP_CENTER: 'Help Center',
    USER_SETTINGS: 'User Settings',
    NETWORK_SETTINGS: 'Network Settings',
    NETWORK_STATUS: 'Network Active',
    EU_EXCLUDE: '(EU Excluded)',
    SIGN_OUT: 'Sign Out',
    NAVBAR_SEARCH_PLACEHOLDER: 'Search for supplies, demands or lists',
    MENU: 'Menu',
    HELP: 'Help',
    ACTIVITY_LOG: 'Activity Log',
    NO_RESULTS: 'No results',
    FILTER: 'Filter',
    HELLO: 'Hello',
    EST: 'EST',
    NAME: 'Name',
    MY_ACCOUNT: 'My account',
    SUPPLY_ID: 'Supply ID',
    SUPPLY_NAME: 'Supply Name',
    SUPPLY_SUB_TYPE: 'Supply Sub Type',
    SUBTYPE_CONTENT_UNIT: 'Sub type Content Unit',
    CDN_MEDIA_TRANSCODING: 'CDN Media Transcoding',
    AD_MANAGER: 'Google AdManager',
    GOOGLE_SLOT_ID: 'Display Ad Unit',
    GOOGLE_SLOT_DIMENSIONS: 'Display Ad Unit Sizes',
    SUPPLY_SUB_TYPE_REGULAR: 'Player',
    SUPPLY_SUB_TYPE_CONTENT_UNIT: 'Content Unit',
    SUPPLY_SUB_TYPE_VPAID: 'Client Side (VPAID)',
    SUPPLY_SUB_TYPE_VAST: 'Server Side (VAST)',
    SUPPLY_SUB_TYPE_EMPTY: '',
    SUPPLY_CONTENT_UNIT_FRAME_SAFE: 'Safeframe',
    SUPPLY_CONTENT_UNIT_FRAME_REGULAR: 'Regular',
    SUPPLY_CONTENT_UNIT_TAG_TYPE_PERSISTENT: 'Persistent',
    SUPPLY_CONTENT_UNIT_TAG_TYPE_INFEED: 'In-Feed',
    DEMAND_ID: 'Demand ID',
    DEMAND_NAME: 'Demand Name',
    DEMAND_TYPE: 'Demand Type',
    DEMAND_SUB_TYPE: 'Demand Sub Type',
    DEMAND_SUB_TYPE_VIDEO: 'Video',
    DEMAND_SUB_TYPE_DISPLAY: 'Display',
    DEMAND_FALLBACK: 'Fallback',
    DEMAND_FR: 'Demand FR',
    DEMAND_URL: 'Demand URL',
    PARTNER_DEMAND_ID: 'Partner Demand ID',
    PARTNER_DEMAND_NAME: 'Partner Demand Name',
    URL: 'Demand URL',
    CPM_SYNC_URL: 'CPM Sync URL',
    BIDDERS_LIST_CANT_BE_LOADED: "Error. Bidders List can't be loaded",
    VENDOR: 'Vendor',
    COST: 'Cost',
    DEMAND_COST: 'Demand Cost',
    AD_REQUESTS: 'Ad Requests',
    IMPRESSIONS: 'Impressions',
    REVENUE: 'Revenue',
    RPM: 'RPM',
    DOMAIN: 'Domain',
    PREBID_URL: 'Prebid URL',
    DETECTED_DOMAIN: 'Domain (detected)',
    DETECTED_DOMAIN_EDITABLE: 'Domain (detected) Edit',
    OPPORTUNITIES: 'Opportunities',
    IMPRESSION_RPM: 'Impression RPM',
    FILTERED_OPPORTUNITIES: 'Filtered Opportunities',
    AD_STARTS_PERCENTAGE: 'Ad Starts%',
    FILLRATE: 'Fill Rate',
    APP_BUNDLE: 'App Bundle',
    APP_BUNDLE_EDITABLE: 'App Bundle Edit',
    DETECTED_APP_BUNDLE: 'App Bundle (detected)',
    SUB_ID: 'Sub ID',
    SUB_ID2: 'Sub ID2',
    SUB_ID3: 'Sub ID3',
    SUB_ID4: 'Sub ID4',
    UTM_CAMPAIGN: 'UTM Campaign',
    UTM_MEDIUM: 'UTM Medium',
    UTM_SOURCE: 'UTM Source',
    UTM_TERM: 'UTM Term',
    UTM_CONTENT: 'UTM Content',
    COUNTRY: 'Country',
    COUNTRY_CODE: 'Country Code',
    ENVIRONMENT: 'Environment',
    ENVIRONMENT_SHORT: 'Env.',
    ENVIRONMENT_DETECTED: 'Env. (detected)',
    USER_AGENT: 'User Agent',
    HOUR: 'Hour',
    DAY: 'Day',
    APP_NAME: 'App Name',
    SUPPLY_TYPE: 'Supply Type',
    PLAYER_SIZE: 'Player Size',
    PLAYER_SIZE_DETECTED: 'Player Size Detected',
    NETWORK_ID: 'Network ID',
    WIDTH: 'Width',
    HEIGHT: 'Height',
    FROM: 'From',
    TO: 'To',
    DATE: 'Date',
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAYS: 'Last 7 Days',
    LAST_MONTH: 'Last Month',
    MONTH_TO_DATE: 'Month to Date',
    LAST_30_DAYS: 'Last 30 Days',
    CUSTOM_RANGE: 'Custom Range',
    DIMENSIONS: 'Dimensions',
    NONE: 'None',
    SELECT_PRESET: 'Select Preset',
    SAVE_PRESET: 'Save Preset',
    SEARCH: 'Search',
    REFRESH_GRID: 'Refresh Grid',
    LEAVE_US_A_MESSAGE: 'Leave Us a Message',
    YOUR_NAME: 'Your name',
    EMAIL_ADDRESS: 'Email address',
    COMPANY: 'Company',
    PRIORITY: 'Priority',
    CRITICAL: 'Critical',
    HIGH: 'High',
    NORMAL: 'Normal',
    LOW: 'Low',
    HOW_CAN_WE_HELP_YOU: 'How can we help you',
    ATTACHMENTS: 'Attachments',
    SEND: 'Send',
    LABS_API_JOB_ACCEPTED: 'A link to the report file will be sent to your email once it will be processed.',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    SAVE: 'Save',
    OK: 'OK',
    OOPS_SOMETHING_WENT_WRONG: 'Oops... something went wrong',
    TRY_TO_REFRESH_THE_PAGE: 'Try to refresh the page',
    COMING_SOON: 'Coming soon',
    PARTNER_LOGIN: 'Partner Login',
    PUBLISHER_LOGIN: 'Publisher Login',
    KEEP_ME_LOGGED_IN: 'Keep me logged in',
    SIGN_IN: 'Sign in',
    USERNAME: 'Username',
    PASSWORD: 'Password',
    CURRENT_PASSWORD: 'Current password',
    ENTER_CURRENT_PASSWORD: 'Enter current password',
    NEW_PASSWORD: 'New password',
    ENTER_NEW_PASSWORD: 'Enter new password',
    CONFIRM_NEW_PASSWORD: 'Confirm new password',
    DESKTOP: 'Desktop',
    MOBILE_WEB: 'Mobile Web',
    MOBILE_APP: 'Mobile App',
    CTV: 'CTV',
    WEB: 'Web',
    APP_OR_CTV: 'In App / CTV',
    NA: 'N/A',
    MOBILE: 'Mobile',
    BOTH: 'Both',
    NOT_DEFINED: 'Not Defined',
    SHOW_INACTIVE: 'Show inactive',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    ASSIGNED: 'Assigned',
    NOT_ASSIGNED: 'Not Assigned',
    SELECT: 'Select',
    UNSELECT: 'Unselect',
    SELECT_ALL: 'Select All',
    UNSELECT_ALL: 'Unselect All',
    REMOVE_SELECTION: 'Remove selection',
    CREATE_NEW: 'Create New',
    CEDATO_MARKET_SETTINGS: 'Cedato Market Settings',
    PARTICIPATE_IN_CEDATOX: 'Participate in CedatoX',
    OFFERING_SUPPLY: 'Offering Supply',
    OFFERING_DEMAND: 'Offering Demand',
    CONTACT_EMAIL: 'Contact Email',
    PLATFORM_API_KEY: 'Platform API Key',
    ACCESS_KEY_IS_GRANTED_PER_NETWORK: 'Access key is granted per network.',
    FOLLOW: 'Follow',
    THIS_LINK: 'this link',
    TO_OUR_HELP_CENTER_FOR_MORE_INFORMATION: 'to our Help Center for more information.',
    CREATE_ACCESS_KEY: 'Create Access Key',
    REGENERATE_ACCESS_KEY: 'Regenerate Access Key',
    ACCESS_KEY: 'Access Key',
    SECRET: 'Secret',
    CREATED: 'Created',
    UPDATED: 'Updated',
    GENERATE_ENCRYPTION_KEY: 'Generate Encryption Key',
    REGENERATE_ENCRYPTION_KEY: 'Regenerate Encryption Key',
    ENCRYPTION_KEY: 'Encryption key',
    ENCRYPTION_KEY_IS_GRANTED_PER_NETWORK: 'Encryption key is granted per network.',
    TEST_ENCRYPTION: 'Test Encryption',
    ENTER_NUMERIC_VALUE: 'Enter Numeric Value',
    ENCRYPTED_VALUE: 'Encrypted Value',
    REGENERATE: 'Regenerate',
    REGENERATE_WARNING_ACCESS_KEY:
      'Please note that your existing ACCESS KEY will be disabled and needs to be replaced with the new created ACCESS KEY',
    REGENERATE_WARNING_ENCRYPTION_KEY:
      'Please note that your existing ENCRYPTION KEY will be disabled and needs to be replaced with the new created ENCRYPTION KEY',
    STATISTICS: 'Statistics',
    CUSTOM_REPORT: 'Custom Report',
    CUSTOM_REPORT_ADMIN: 'Custom Report (Admin)',
    OF: 'of',
    ITEMS: 'items',
    ITEMS_CAP: 'Items',
    ITEMS_PER_PAGE: 'items per page',
    TOTAL: 'Total',
    EXPORT: 'Export',
    SORT_ASCENDING: 'Sort Ascending',
    SORT_DESCENDING: 'Sort Descending',
    SHOW_DEFAULT_COLUMNS: 'Show Default Columns',
    PRESENT: 'Present',
    HIDE: 'Hide',
    FILTERS_ON_TABLE: 'Filters on Table',
    GENERATING_REPORT: 'Generating Report',
    NO_DATA: 'No Data',
    REPORT_SENT_BY_EMAIL: 'Report will be sent by email',
    NO_ITEMS: 'No items',
    MANAGE_SUPPLY: 'Manage Supply',
    MANAGE_DEMAND: 'Manage Demand',
    MANAGE_LISTS: 'Manage Lists',
    MANAGE_CDN: 'Manage CDN Files',
    CDN_UPLOAD: 'CDN Upload',
    ASSIGNED_DEMAND: 'Assigned Demand',
    ASSIGNED_DEMANDS: 'Assigned Demand Items',
    TYPE: 'Type',
    REPORT_TYPE: 'Report Type',
    REPORT_FREQUENCY: 'Report Frequency',
    WHITE: 'White',
    BLACK: 'Black',
    WHITELIST: 'Whitelist',
    BLACKLIST: 'Blacklist',
    SELECT_LIST: 'Select List',
    ADD_TO_LIST: 'Add to List',
    ADD_TO_LIST_PLACEHOLDER_IP: 'Add IPs manually',
    ADD_TO_LIST_PLACEHOLDER_BUNDLE: 'Add Bundles/Domains manually',
    ADD_TO_LIST_PLACEHOLDER_URL: 'Add URLs manually',
    ADD_TO_LIST_PLACEHOLDER_SCHAIN: 'Add Supply Chain values manually',
    ADDED_LIST_SUCCESS_MESSAGE: (number: number) =>
      `${number} Domains/IPs/URLs are added to the list. Changes will be effective after save.`,
    ADDED_LIST_FAILURE_MESSAGE: (number: number) =>
      `${number} Domains/IPs/URLs were invalid/duplicated, and will not be added to the list.`,
    REMOVED_LIST_SUCCESS_MESSAGE: (number: number) =>
      `${number} Domains/IPs/URLs are removed from list. Changes will be effective after save.`,
    UPLOAD_DOMAINS_SUCCESS: (good: number, bad: number) =>
      `A total of ${good} domains or applications names were uploaded, ${bad} of those were found to be invalid domains or applications.`,
    LIST_CHANGES_NOTIFICATION: '* Changes will be saved after "Save" button is clicked',
    REQUEST_LIMIT: 'Request Limit',
    PREMIUM: 'Premium',
    PREMIUM_DEMAND_SUPPLYX_NOT_ALLOWED:
      'This Demand is assigned to a Supply, type Cedato X. A Premium Demand cannot be used in a Cedato X connection. Please unassign this Demand from all Cedato X Supply connections to be able to set it as Premium',
    PREMIUM_DEMAND_BOOST_NOT_ALLOWED: "Demand can't be Boosted and Premium at the same time",
    CPM: 'CPM',
    LIST_NAME: 'List Name',
    LIST_FILE: 'List File',
    LIST_TYPE: 'List Type',
    LIST_ID: 'List ID',
    NUMBER_OF_ITEMS: 'Number of Items',
    USED_BY: 'Used by',
    CREATED_AT: 'Created At',
    UPDATED_AT: 'Updated At',
    FILE_URL: 'File URL',
    FILE_NAME: 'File Name',
    ID: 'ID',
    SIZE_KB: 'Size (KB)',
    NEW_SUPPLY: 'New Supply',
    NEW_DEMAND: 'New Demand',
    NEW_LIST: 'New List',
    EDIT_SUPPLY: 'Edit Supply',
    EDIT_DEMAND: 'Edit Demand',
    EDIT_LIST: 'Edit List',
    CDN_FILE_UPLOAD: 'CDN File Upload',
    CDN_FILE_MRSS_UPDATE: 'MRSS File Update',
    MULTI_BITRATE_UPLOAD: 'Multi Bit-Rate Upload',
    MULTI_BITRATE: 'Multi Bit-Rate',
    ENTER_FILE_NAME: 'Enter File Name',
    FILE_NAME_ON_CDN: 'File name on CDN',
    BROWSE_LOCAL_FILES: 'Browse local files',
    SELECT_A_FILE_TO_UPLOAD: 'Select a File to Upload',
    UPLOAD_CDN_LIMITS:
      'Allowed file types: gif, jpg, png, jpeg, mp4, webm, ogv, m4v, xml, mrss and json. Maximum allowed file size: 50 MB.',
    UPLOAD: 'Upload',
    CDN_FILE_DELETE: 'CDN File Delete',
    CDN_FILE_DELETE_CONFIRM: 'Are you sure you want to delete this file?',
    FILE_ID: 'File ID',
    ADDED_SUCCESSFULLY: 'Added Successfully',
    REMOVED_SUCCESSFULLY: 'Removed Successfully',
    UPDATED_SUCCESSFULLY: 'Updated Successfully',
    FILE_UPLOADED_SUCCESSFULLY: 'File Uploaded Successfully',
    FILE_DELETED_SUCCESSFULLY: 'File Deleted Successfully',
    FILE_NAME_IS_REQUIRED: 'File name is required',
    RTB_PARTNER_IS_REQUIRED: 'RTB Partner is required',
    PLEASE_SELECT_A_FILE:
      'Please select a file with allowed file type (gif, jpg, png, jpeg, mp4, webm, ogv, m4v, xml, mrss or json).',
    CREATE_A_NEW_LIST: 'Create a New List',
    ENTER_LIST_NAME: 'Enter list name',
    UPLOAD_NEW_LIST: 'Upload the new list',
    UPLOAD_LIST_COMMENT: (fileSize) => `Max ${fileSize}MB .txt file (ANSI encoded); One item per line`,
    EXPORT_ALL_DATA: 'Export All Data (.csv)',
    EXPORT_ALL_DATA_COMMENT: '* Note: Export limited to 1M rows',
    EXPORT_VISIBLE_DATA: 'Export Visible Data (.csv)',
    CLEAR_FILTERS: 'Clear Filters',
    HTML_PLAYER: 'HTML Player',
    VAST: 'VAST',
    CEDATOX: 'CedatoX',
    SPOTX_DIRECT: 'SpotX Direct',
    RTB: 'RTB',
    ENTER_JSON: 'Enter JSON here',
    ENTER_URL_PARAMS: 'Enter URL Parameters here',
    JSON_NOT_VALID: 'Extra Params JSON syntax error',
    URL_PARAMS_NOT_VALID: 'URL Parameters syntax error',
    EXTRA_PARAMS_TOO_LONG: 'Extra Params are too long',
    JSON_UNDEFINED: 'Extra Params wasn’t defined',
    EXTRA_PARAMS: 'Extra Params',
    INITIAL_PARAMS: 'Initial Params',
    JSON_PARAMS: 'JSON Params',
    DEMAND_EXTRA_PARAMS: 'Demand Extra Params',
    PREBID_PARTNER: 'Prebid Partner',
    PREBID_CONFIG_JSON: 'Prebid Configuration JSON',
    PREBID_JSON_NOT_VALID: 'Prebid JSON syntax error',
    TYPE_BIDDER_NAME: 'Type Bidder Name',
    VASTCTV: 'VastCTV',
    PREBID_VAST_TYPE: 'Prebid',
    PREBID_VAST: 'Prebid Demand Type',
    VIDEO: 'Video',
    TEXT: 'Text',
    IMAGE: 'Image',
    APPLICATION: 'Application',
    YES: 'Yes',
    NO: 'No',
    NOT_PROVIDED_BY_SOURCE: 'Not provided by source',
    NOT_PROVIDED_BY_SOURCE_TOOLTIP:
      "An entry in the domain column that is marked as 'Not provided by source' implies that Cedato did not receive a value from the media source. Please contact your media source.",
    NETWORK: 'Network',
    CHANGE_NETWORK: 'Change Network',
    SEARCH_NETWORK: 'Search for a Network',
    COPY_NETWORK_ID: 'Copy Network ID',
    EXPORTED_DATA: 'Exported_data',
    SETTINGS: 'Settings',
    ASSIGN_DEMAND: 'Assign Demand',
    TAG: 'Tag',
    TAG_LINK: 'Tag Link',
    RESTRICTIONS: 'Restrictions',
    TARGETING: 'Targeting',
    CALLBACKS: 'Callbacks',
    FLOOR_CPM_PRICE: 'Floor CPM Price ($)',
    SUPPLY_COST_TYPE: 'Supply Cost Type',
    ALLOW_SOUND: 'Allow Sound',
    ROTATION: 'Rotation',
    HTML5_ONLY: 'HTML5 Only',
    AUTO_PLAY: 'Auto Play',
    CONTROL_BAR: 'Control Bar',
    POSTER_IMAGE: 'Poster Image',
    CONTENT_VIDEO: 'Content Video',
    SHUFFLE_VIDEO_PLAYLIST: 'Shuffle Video Playlist',
    ADD_CONTENT_DESCRIPTION: 'Add Content Description',
    VIDEO_DESCRIPTION: 'Video Description',
    VIDEO_KEYWORDS: 'Video Keywords',
    VIDEO_TITLE: 'Video Title',
    ADD_VIDEO_DESCRIPTION: 'Add video description',
    ADD_VIDEO_KEYWORDS: 'Add video keywords: Keyword1, Keyword2, ...',
    ADD_VIDEO_TITLE: 'Add video title',
    CHARACTERS: 'Characters',
    AS_SOON_AS_AVAILABLE: 'As soon as available',
    PRE_ROLL: 'Pre Roll',
    PRE_ROLL_DEMAND: 'Pre Roll Demand',
    MID_ROLL: 'Mid Roll',
    POST_ROLL: 'Post Roll',
    LOOP_CONTENT: 'Loop Content',
    SHOW_CONTROL_BAR_ON_CONTENT_PLAYBACK_ONLY: 'Show control bar on content playback only',
    CONTENT_CLICK_URL: 'Content Click URL',
    SUPPLY_PARTNER: 'Supply Partner',
    NETWORK_DOMAIN_NAME: 'Network Domain Name',
    PREVIEW: 'Preview',
    SIZE: 'Size',
    SECURE: 'Secure',
    PASSBACK: 'Passback',
    ACTIVATE: 'Activate',
    SET_TIMEOUT: 'Set timeout',
    SECONDS_SHORT: 'sec.',
    IF_NEEDED_MANUALLY_EDIT_THE_TAB_BELOW: "If needed, manually edit the tag below. If edited, changes won't be saved.",
    IF_NEEDED_MANUALLY_EDIT_THE_TAB_BELOW_SAVEABLE: 'Changes bellow will be taken into effect after saving.',
    VIEW_ADDITIONAL_SUPPLY_PARAMETERS: 'View additional supply parameters',
    ADD_CALLBACK: 'Add Callback',
    CALLBACK_URL: 'Callback URL',
    ENTER_CALLBACK_URL: 'Enter callback URL',
    ENTER_CALLBACK_RATE: 'Enter callback rate',
    ADD_ANOTHER: 'Add another',
    BACK_TO_TOP: 'Back to top',
    SAVE_AND_EXIT: 'Save & Exit',
    REVSHARE: 'Revshare',
    FIXED_CPM: 'Fixed CPM',
    FIXED_CPM_PER_OPPORTUNITIES: 'Fixed CPM per Opportunities',
    FIXED_CPM_PER_IMPRESSIONS: 'Fixed CPM per Impressions',
    UNLIMITED: 'Unlimited',
    ENTER_IMAGE_URL: 'Enter image URL',
    ENTER_VIDEO_URL: 'Enter video URL',
    ENTER_MRSS_URL: 'Enter MRSS URL',
    ENTER_CLICK_URL: 'Enter click URL',
    VAST_REQUEST_LIMIT: 'VAST Request Limit',
    MAXIMUM_AD_REQUESTS_PER_OPPORTUNITY: 'Maximum ad requests per opportunity',
    SHOW_PREVIOUSLY_ASSIGNED_DEMAND: 'Show previously assigned demand',
    SHOW_INACTIVE_DEMAND: 'Show inactive demand',
    VIEW_AVAILABLE_MACROS: 'View Available Macros',
    AVAILABLE_MACROS: 'Available Macros',
    MACRO: 'Macro',
    DESCRIPTION: 'Description',
    INCLUDE: 'Include',
    EXCLUDE: 'Exclude',
    CONTAINS: 'Contains',
    REGEX: 'Regex',
    GO: 'Go',
    CLEAR: 'Clear',
    SAVE_REPORT: 'Save Report',
    COPY_REPORT: 'Copy Report',
    DELETE_REPORT: 'Delete Report',
    ENTER_REPORT_NAME: 'Enter report name',
    REPORT_NAME: 'Report Name',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_REPORT: 'Are you sure you want to delete this report?',
    ARE_YOU_SURE: 'Are you sure?',
    DELETE: 'Delete',
    DOWNLOAD: 'Download',
    COPY: 'Copy',
    EDIT: 'Edit',
    COPY_SUPPLY: 'Copy Supply',
    COPY_DEMAND: 'Copy Demand',
    COPY_LIST: 'Copy List',
    SEARCH_LIST: 'Search List',
    SEARCH_DISABLED: 'The list has exceeded the amount of items that can be edited online.',
    REPORT_NAME_IS_REQUIRED: 'Report name is required',
    REPORT_NAME_ALREADY_IN_USE: 'Report name is already in use. Please choose a unique name.',
    SUCCESS: 'Success',
    ERROR: 'Error',
    WARNING: 'Warning',
    AN_ERROR_HAS_OCCURRED: 'An error has occurred',
    SUPPLY_NOT_FOUND: 'Supply not found',
    DEMAND_NOT_FOUND: 'Demand not found',
    LIST_NOT_FOUND: 'List not found',
    NETWORK_NOT_FOUND: 'Network not found',
    REPORT_NOT_FOUND: 'Report not found',
    CONTACT_SUPPORT_FOR_HELP: 'Contact Support for Help',
    PLEASE_CHOOSE_A_VALID_DATE: 'Please choose a valid date',
    THE_REPORT_WAS_SAVED: 'The report was saved.',
    THE_REPORT_WAS_DELETED: 'The report was deleted.',
    SUPPLY_NAME_IS_REQUIRED: 'Supply name is required',
    SUPPLY_NAME_IS_ALREADY_IN_USE: 'Supply name is already in use',
    AT_LEAST_ONE_ENVIRONMENT_IS_REQUIRED: 'At least one Environment is required',
    COST_VALUE_IS_REQUIRED: 'Cost value is required, and must be at least 0.01',
    FLOOR_CPM_IS_REQUIRED: 'Floor CPM is required, and must be at least 0.01',
    FLOOR_CPM_IS_INVALID: 'Floor CPM must be at least 0.01',
    MAX_DURATION_IS_INVALID: 'Max duration must be at least 0.01',
    PUSH_PERCENTAGE_IS_REQUIRED: 'Push percentage is required, and must be between 0.01 and 1',
    CEDATOX_SUPPLY_REVSHARE_COMMENT_TITLE: 'Please check the revshare',
    CEDATOX_SUPPLY_REVSHARE_COMMENT_INFO: (number: number) =>
      `The revshare ${number}% is out of the customary range, please double check and proceed.`,
    PARTNER_NETWORK_ID_IS_REQUIRED: 'Partner Network ID is required',
    PLAY_AD_IS_MISSING: 'Play Ad: It is not allowed not to choose a setting',
    PREROLL_IS_REQUIRED: 'Preroll is checked, so its value is required (between 1 and 100)',
    MIDROLL_IS_REQUIRED: `* Play Ad: Minimum time for "First Ad will play after" is 20 sec.<br/>* Minimum time for "Mid Roll Time Interval" is 30 sec.<br/>* Minimum time for "Allowed Delay for Playing The Ad" is 3 sec.<br/>* "Allowed delay for playing the ad" should be shorter than "Mid roll time interval".`,
    MIDROLL_IS_INVALID: `Play Ad: "Allowed delay for playing the ad" should be shorter than "Mid roll time interval".`,
    PASSBACK_TIMEOUT_ERROR: 'Passback timeout must be between 15 and 999,999 seconds',
    PASSBACK_CODE_IS_REQUIRED: 'Passback code is required',
    WIDTH_IS_REQUIRED: 'Width is required',
    HEIGHT_IS_REQUIRED: 'Height is required',
    MAXIMUM_AD_REQUESTS_PER_OPPORTUNITY_CANT_BE_BELOW_ZERO: "Maximum ad requests per opportunity can't be below zero",
    RESTRICTION_LISTS_ARE_REQUIRED:
      'You selected a List Type but did not add a list. Please specify at least one Blacklist or Whitelist accordingly',
    RESTRICTION_LISTS_LIMIT_REACHED: "Please select a maximum of 30 restriction lists.'",
    IP_LISTS_LIMIT_REACHED: 'Please select a maximum of 5 IP restriction lists.',
    DOMAIN_LISTS_LIMIT_REACHED: 'Please select a maximum of 30 Domain restriction lists.',
    USER_MVR_NOT_VALID: (str: string = '49') => `Vast Request limit should be between 1 and ${str}.`,
    CUSTOM_MVR: 'User Mvr By Value',
    EMPTY_CALLBACKS_ERROR: 'Callback URL is required',
    INVALID_URL_CALLBACKS_ERROR: 'Callback URL is invalid',
    DOUBLED_CALLBACKS_ERROR:
      'It is not allowed to have more than one callback with the same URL and Event type. This can cause discrepancies with your 3rd party service provider. Please remove the duplicated callbacks.',
    CALLBACKS_RATE_ERROR: 'Impressions to sample (%) must have a value within the following range: 0-100.',
    CALLBACK_IVT_ERROR: 'Please make sure the URL is correct, in case it is, please contact your Account Manager.',
    TARGETING_LOCATION_ERROR: "Countries list: Can't be empty",
    TARGETING_BROWSERS_ERROR: "Browsers list: Can't be empty",
    TARGETING_BROWSERS_FROM_TO_ERROR: "Browsers list: the 'from' version can't be greater than the 'to' version",
    TARGETING_OS_ERROR: "Operating Systems list: Can't be empty",
    TARGETING_OS_FROM_TO_ERROR: "Operating Systems list: the 'from' version can't be greater than the 'to' version",
    TARGETING_SIZE_ERROR: "Player Size: Can't be empty",
    TARGETING_SIZE_WIDTH_HEIGHT_ERROR: 'Player Size: width and height must be greater than zero',
    TARGETING_VIEWABILITY_ERROR: 'Viewability: the viewability goal must be between 1 and 100',
    TARGETING_IVT_ERROR: 'IVT: the IVT goal must be between 1 and 100',
    TARGETING_USER_MVR_INPUT_TYPE_BY_SCALE: 'By Scale',
    TARGETING_USER_MVR_INPUT_TYPE_BY_VALUE: 'By Value',
    DEMAND_NAME_IS_REQUIRED: 'Demand name is required',
    PRICE_FACTOR_ERROR: 'The price factor value must be between 1 and 100',
    GOOGLE_MACRO_SUPPRESSION_ERROR: 'Google macro suppression % must be between 0 and 100',
    CPM_IS_REQUIRED: 'CPM is required, and must be at least 0.01',
    URL_IS_REQUIRED: 'URL is required',
    URL_IS_INVALID: 'URL is invalid',
    DEAL_ID_IS_REQUIRED: 'Deal ID is required',
    CAPPING_ERROR: 'Capping restriction is invalid',
    CAPPINGS_ERROR: 'One or more capping restrictions is invalid',
    REPORT_NAME_ERROR: "Report Name: Can't be empty",
    REPORT_FREQUENCY_ERROR: "Report Frequency: It's necessary select one",
    MAX_CPM_LIMIT: 'Max CPM limit',
    MIN: 'Min',
    MAX: 'Max',
    LOAD_MORE: 'Load More',
    UNKNOWN_USER: 'Unknown user',
    DOMAIN_ID: 'Domain ID',
    DOMAIN_TYPE: 'Domain Type',
    NETWORK_TYPE: 'Network Type',
    SHARED_DOMAINS: 'Shared Domains',
    EXCLUSIVE_DOMAINS: 'Exclusive Domains',
    ADD_NETWORK: 'Add Network',
    EDIT_NETWORK: 'Edit Network',
    DELETE_NETWORK: 'Delete Network',
    EDIT_PRICING_DETAILS: 'Edit pricing details',
    EDIT_FINANCE_DETAILS: 'Edit finance details',
    PRICING_DETAILS: 'Pricing Details',
    FINANCE_DETAILS: 'Finance Details',
    DESKTOP_TRAFFIC: 'Desktop traffic',
    MOBILE_TRAFFIC: 'Mobile traffic',
    OPPORTUNITY: 'Opportunity',
    IMPRESSION: 'Impression',
    HTML: 'HTML',
    NEW_MSA: 'New MSA - VAST min Fill Rate',
    MONTHLY_MINIMUM: 'Monthly Minimum',
    CDN_FEE: 'CDN Fee',
    GENERAL_FEE: 'General Fee',
    POST_BID_FEE: 'Post-Bid Fee',
    MOAT_FEE: 'Moat Fee',
    DISCOUNTS: 'Discounts',
    TIERS: 'Tiers',
    CDN_USAGE: 'CDN Usage',
    BANDWIDTH: 'Bandwidth (GB)',
    TRAFFIC_VOLUME: 'Traffic Volume',
    FREE: 'Free',
    STANDARD: 'Standard',
    CHOOSE_Q_AND_V_PROVIDER: 'Choose Q&V Provider',
    ADD_A_PROVIDER: 'Add a Provider',
    SPECIAL_DISCOUNT: 'Special Discount',
    SPECIAL_CHARGE: 'Special Charge',
    COMMENTS: 'Comments',
    PRICING_DISCOUNT_DUPLICATE_ERROR: 'These environment and bandwith were already selected together.',
    PRICING_DISCOUNT_EMPTY_ERROR: "A tier fee/discount can't be empty.",
    PRICING_QUALITY_AND_VIEWABILITY_DUPLICATE_ERROR: 'This Quality & Viewability partner was already selected.',
    PRICING_QUALITY_AND_VIEWABILITY_EMPTY_ERROR: 'A Quality & Viewability partner was not selected.',
    PRICING_EDIT_SUCCESS: 'Pricing details were saved successfully',
    BILLING_REPORT: 'Billing Report',
    BILLING_REPORT_CSV_NAME: 'BillingReport',
    ACCOUNT_MANAGER: 'Account Manager',
    DESKTOP_HTML_IMP: 'Desktop HTML Impression',
    DESKTOP_HTML_OPP: 'Desktop HTML Opportunity',
    DESKTOP_CEDATOX_IMP: 'Desktop CedatoX Impression',
    DESKTOP_CEDATOX_OPP: 'Desktop CedatoX Opportunity',
    DESKTOP_VAST_IMP: 'Desktop VAST Impression',
    DESKTOP_VAST_OPP: 'Desktop VAST Opportunity',
    MOBILE_HTML_IMP: 'Mobile HTML Impression',
    MOBILE_HTML_OPP: 'Mobile HTML Opportunity',
    MOBILE_CEDATOX_IMP: 'Mobile CedatoX Impression',
    MOBILE_CEDATOX_OPP: 'Mobile CedatoX Opportunity',
    MOBILE_VAST_IMP: 'Mobile VAST Impression',
    MOBILE_VAST_OPP: 'Mobile VAST Opportunity',
    DESKTOP_HTML_IMP_FEE: 'Desktop HTML Impression Fee',
    DESKTOP_HTML_OPP_FEE: 'Desktop HTML Opportunity Fee',
    DESKTOP_CEDATOX_IMP_FEE: 'Desktop CedatoX Impression Fee',
    DESKTOP_CEDATOX_OPP_FEE: 'Desktop CedatoX Opportunity Fee',
    DESKTOP_VAST_IMP_FEE: 'Desktop VAST Impression Fee',
    DESKTOP_VAST_OPP_FEE: 'Desktop VAST Opportunity Fee',
    MOBILE_HTML_IMP_FEE: 'Mobile HTML Impression Fee',
    MOBILE_HTML_OPP_FEE: 'Mobile HTML Opportunity Fee',
    MOBILE_CEDATOX_IMP_FEE: 'Mobile CedatoX Impression Fee',
    MOBILE_CEDATOX_OPP_FEE: 'Mobile CedatoX Opportunity Fee',
    MOBILE_VAST_IMP_FEE: 'Mobile VAST Impression Fee',
    MOBILE_VAST_OPP_FEE: 'Mobile VAST Opportunity Fee',
    MESSAGE_TEXT: 'Message Text',
    MESSAGE_TEXT_IS_REQUIRED: 'Message text is required',
    COLOR: 'Color',
    STATUS: 'Status',
    RED: 'Red',
    YELLOW: 'Yellow',
    GREEN: 'Green',
    PUBLISH: 'Publish',
    USER_ID: 'User ID',
    NETWORK_NAME: 'Network Name',
    LAST_LOGIN_TIME: 'Last Login Time',
    EMAIL: 'Email',
    IS_SECURED: 'Is Secured',
    USER_AGENTS_LIST: 'User agents list',
    SERVER: 'Server',
    SUBMIT: 'Submit',
    CONFIRM: 'Confirm',
    RESET: 'Reset',
    BACK: 'Back',
    DISMISSED: 'Dismissed',
    PUBLISHED: 'Published',
    DRAFT: 'Draft',
    SAVE_DRAFT: 'Save Draft',
    CX_SUPPLY_ID: 'Cx Supply ID',
    CX_DEMAND_ID: 'Cx Demand ID',
    MID_CX_SUPPLY_ID: 'Mid. Cx Supply ID',
    MID_CX_DEMAND_ID: 'Mid. Cx Demand ID',
    CAPPING: 'Capping',
    FLOOR_CPM: 'Floor CPM',
    IGNORE_ML: 'Ignore ML recommended floor price',
    MAX_DURATION: 'Max Duration',
    PUSH_PERCENTAGE: 'Push Percentage',
    OS: 'OS',
    BROWSER: 'Browser',
    VAST_DOMAINS: 'Exclude VAST Vendors Domains',
    LISTS: 'Lists',
    GENERIC: 'Generic',
    SCORE: 'Score',
    IS_MISSING: 'is missing',
    MONTH: 'Month',
    YEAR: 'Year',
    DOWNLOAD_REPORT: 'Download Report',
    SAMPLED_SUPPLY: 'Sampled Supply',
    SAMPLED_DEMAND: 'Sampled Demand',
    ALL_SAMPLED_SUPPLY_BY_DOMAIN: 'All Sampled Supply by Domain',
    PLAYER_LOADS: 'Player Loads',
    SAMPLED_IMPRESSIONS: 'Sampled Impressions',
    MESSAURED_IMPRESSIONS: 'Meassured Impressions',
    HIGH_RISK_PERCENTAGE: 'High Risk%',
    SUSPECT_PERCENTAGE: 'Suspect%',
    VIEWABILITY: 'Viewability',
    VIEWABILITY_SAMPLED: 'Viewability Sampled',
    VIEWED_1S_PERCENTAGE: 'Viewed 1%',
    VIEWED_2S_PERCENTAGE: 'Viewed 2%',
    VIEWED_5S_PERCENTAGE: 'Viewed 5%',
    VIEWED_10S_PERCENTAGE: 'Viewed 10%',
    VIEWED_15S_PERCENTAGE: 'Viewed 15%',
    VIEWED_25S_PERCENTAGE: 'Viewed 25%',
    VIEWED_30S_PERCENTAGE: 'Viewed 30%',
    UNDETERMINED: 'Undetermined',
    NEW_NAME: 'New Name',
    MESSAGE_COLOR: 'Message Color',
    SAVE_AS: 'Save As',
    BY: 'By',
    CDN_REGULAR_FEE: 'CDN Regular Fee',
    PRICE_OVER_HALF_TB: 'Price Over 0.5TB',
    PRICE_OVER_5_TB: 'Price Over 5TB',
    PRICE_OVER_50_TB: 'Price Over 50TB',
    PRICE_OVER_60_TB: 'Price Over 60TB',
    PRICE_OVER_100_TB: 'Price Over 100TB',
    PRICE_OVER_500_TB: 'Price Over 500TB',
    PRICE_OVER_50_MB_BOTH: 'Price Over 50MB (Both)',
    PRICE_OVER_100_MB_BOTH: 'Price Over 100MB (Both)',
    PRICE_OVER_125_MB_BOTH: 'Price Over 125MB (Both)',
    PRICE_OVER_150_MB_BOTH: 'Price Over 150MB (Both)',
    PRICE_OVER_200_MB_BOTH: 'Price Over 200MB (Both)',
    PRICE_OVER_250_MB_BOTH: 'Price Over 250MB (Both)',
    PRICE_OVER_350_MB_BOTH: 'Price Over 350MB (Both)',
    PRICE_OVER_400_MB_BOTH: 'Price Over 400MB (Both)',
    PRICE_OVER_450_MB_BOTH: 'Price Over 450MB (Both)',
    PRICE_OVER_500_MB_BOTH: 'Price Over 500MB (Both)',
    PRICE_OVER_700_MB_BOTH: 'Price Over 700MB (Both)',
    PRICE_OVER_750_MB_BOTH: 'Price Over 750MB (Both)',
    PRICE_OVER_1000_MB_BOTH: 'Price Over 1000MB (Both)',
    PRICE_OVER_50_MB_MOBILE: 'Price Over 50MB (Mobile)',
    PRICE_OVER_100_MB_MOBILE: 'Price Over 100MB (Mobile)',
    PRICE_OVER_125_MB_MOBILE: 'Price Over 125MB (Mobile)',
    PRICE_OVER_150_MB_MOBILE: 'Price Over 150MB (Mobile)',
    PRICE_OVER_200_MB_MOBILE: 'Price Over 200MB (Mobile)',
    PRICE_OVER_250_MB_MOBILE: 'Price Over 250MB (Mobile)',
    PRICE_OVER_350_MB_MOBILE: 'Price Over 350MB (Mobile)',
    PRICE_OVER_400_MB_MOBILE: 'Price Over 400MB (Mobile)',
    PRICE_OVER_450_MB_MOBILE: 'Price Over 450MB (Mobile)',
    PRICE_OVER_500_MB_MOBILE: 'Price Over 500MB (Mobile)',
    PRICE_OVER_700_MB_MOBILE: 'Price Over 700MB (Mobile)',
    PRICE_OVER_750_MB_MOBILE: 'Price Over 750MB (Mobile)',
    PRICE_OVER_1000_MB_MOBILE: 'Price Over 1000MB (Mobile)',
    PRICE_OVER_50_MB_DESKTOP: 'Price Over 50MB (Desktop)',
    PRICE_OVER_100_MB_DESKTOP: 'Price Over 100MB (Desktop)',
    PRICE_OVER_125_MB_DESKTOP: 'Price Over 125MB (Desktop)',
    PRICE_OVER_150_MB_DESKTOP: 'Price Over 150MB (Desktop)',
    PRICE_OVER_200_MB_DESKTOP: 'Price Over 200MB (Desktop)',
    PRICE_OVER_250_MB_DESKTOP: 'Price Over 250MB (Desktop)',
    PRICE_OVER_350_MB_DESKTOP: 'Price Over 350MB (Desktop)',
    PRICE_OVER_400_MB_DESKTOP: 'Price Over 400MB (Desktop)',
    PRICE_OVER_450_MB_DESKTOP: 'Price Over 450MB (Desktop)',
    PRICE_OVER_500_MB_DESKTOP: 'Price Over 500MB (Desktop)',
    PRICE_OVER_700_MB_DESKTOP: 'Price Over 700MB (Desktop)',
    PRICE_OVER_750_MB_DESKTOP: 'Price Over 750MB (Desktop)',
    PRICE_OVER_1000_MB_DESKTOP: 'Price Over 1000MB (Desktop)',
    HTML_FILLRATE: 'HTML Fillrate',
    VAST_FILLRATE: 'VAST Fillrate',
    CEDATOX_FILLRATE: 'CedatoX Fillrate',
    IMPRESSIONS_MOBILE: 'Impressions Mobile',
    IMPRESSIONS_DESKTOP: 'Impressions Desktop',
    IMPRESSIONS_TOTAL: 'Impressions Total',
    OPPORTUNITIES_TOTAL: 'Opportunities Total',
    SERVING_FEE: 'Serving Fee',
    VOLUME_DISCOUNT: 'Volume Discount',
    TRAFFIC_FEE: 'Traffic Fee',
    PROTECTED_MEDIA_IMPS: 'Protected Media Impressions',
    PROTECTED_MEDIA_PRICE: 'Protected Media Price',
    PROTECTED_MEDIA_FEE: 'Protected Media Fee',
    FORENSIQ_IMPS: 'Forensiq Impressions',
    FORENSIQ_PRICE: 'Forensiq Price',
    FORENSIQ_FEE: 'Forensiq Fee',
    QUALITY_TOTAL_FEE: 'Total Q&V Fee',
    TOTAL_FEE: 'Total Fee',
    TWO_ENVIRONMENTS_MAX_WARNING: 'A maximum of two environments can be selected',
    CTV_ENVIRONMENT_MAX_WARNING: 'Only CTV environment can be selected',
    PARTNER_NETWORK_ID: 'Partner Network ID',
    PARTNER_NETWORK_ID_NAME: 'Partner Network ID/Name',
    COST_VALUE_REVSHARE: 'Revshare (%)',
    COST_VALUE_FIXED_CPM: 'CPM ($)',
    TAG_TYPE: 'Tag Type',
    UNIT_TYPE: 'Unit Type',
    BASIC_PLAYER: 'Basic Player',
    IN_FEED: 'In-Feed/Large Player',
    IN_FEED_FOR_DFP: 'In-Feed/Large Player for DFP',
    IN_CONTENT: 'In-Content',
    IN_CONTENT_FOR_DFP: 'In-Content for DFP',
    PERSISTENT: 'Persistent',
    PERSISTENT_FOR_DFP: 'Persistent for DFP',
    CORNER: 'Corner',
    CORNER_FOR_DFP: 'Corner for DFP',
    PARALLAX: 'Parallax',
    BASIC_PLAYER_TOOLTIP: 'Placed in a banner placement.',
    IN_FEED_TOOLTIP:
      'Placed within standard web page content and articles or within a list of content items. The In-Feed Unit appears immediately on the webpage when it is loaded.',
    IN_FEED_FOR_DFP_TOOLTIP:
      'In-Feed with a dedicated code for DFP integration - placed within standard web page content and articles or within a list of content items. The In-Feed Unit appears immediately on the webpage when it is loaded.',
    IN_CONTENT_TOOLTIP:
      'Placed within standard web page content and articles or within a list of content items. The In-Content Unit is not visible until 50% (can be adjusted) of its expected height is in the viewable screen and can be configured to get hidden once it finishes playing.',
    IN_CONTENT_FOR_DFP_TOOLTIP:
      'In-Content with a dedicated code for DFP integration - Placed within a standard web page content and articles or within a list of content items. The In-Content Unit is not visible until 50% (can be adjusted) of its expected height is in the viewable screen and can be configured to get hidden once it finishes playing.',
    PERSISTENT_TOOLTIP:
      'Persistent appears within a standard content page or list of content items, and shrinks to a smaller unit as the user scrolls, remaining persistently viewable on the sidebar during the page visit.',
    PERSISTENT_FOR_DFP_TOOLTIP:
      'Persistent with a dedicated code for DFP integration - appears within a standard content page or list of content items, and shrinks to a smaller unit as the user scrolls, remaining persistently viewable on the sidebar during the page visit.',
    CORNER_TOOLTIP: 'Аppears as a steady unit, remaining persistently viewable on the sidebar during the page visit.',
    CORNER_FOR_DFP_TOOLTIP:
      'Corner with a dedicated code for DFP integration - appears as a steady unit, remaining persistently viewable on the sidebar during the page visit.',
    PARALLAX_TOOLTIP:
      'Parallax is placed within a standard content page or list of content items. As the user scrolls down the page, a new section is formed within the content, pushing down the bottom part of the webpage and enabling a full view of the responsive ad on an empty screen.',
    TAG_TYPES_INFO: 'For more details regarding the Supply Tag type please',
    CLICK_HERE: 'click here',
    HERE: 'here',
    ADVANCED_OPTIONS: 'Advanced Options',
    CEDATOX_CONNECTION: 'CedatoX Connection',
    CEDATOX_CONNECTION_MESSAGE: 'Are you sure you want to share this CedatoX with this Partner?',
    PARTNER_ID: 'Partner ID',
    PARTNER_NAME: 'Partner Name',
    INCLUDE_OR_EXCLUDE_DOMAINS: 'Include or Exclude Domains, App Names or App Bundles:',
    INCLUDE_OR_EXCLUDE_IP_ADDRESSES: 'Include or Exclude IP Addresses:',
    INCLUDE_OR_EXCLUDE_URLS: 'Include or Exclude URLs:',
    SELECT_LIST_TYPE: 'Select List Type',
    TRAFFIC_SOURCE_LIMIT_LABEL: 'Receive traffic from supply type:',
    NAVIGATE_OUT_OF_THIS_PAGE: 'Navigate out of this page?',
    NAVIGATE_OUT_OF_THIS_PAGE_MESSAGE1: 'You will lose unsaved changes.',
    NAVIGATE_OUT_OF_THIS_PAGE_MESSAGE2: 'Are you sure you want to navigate away?',
    LEAVE: 'Leave',
    STAY: 'Stay',
    NEW_SUPPLY_SETTINGS_DISCLAIMER: '* Settings may take up to 10 minutes to be updated',
    MATCH_TO_DIV: 'Match to Div',
    WIDTH_X_HEIGHT: 'Width x Height',
    RATIO: 'Ratio',
    CLOSE_BUTTON: 'Close Button',
    CLOSE_ON_AD_END: 'Close on Ad End',
    CLOSE_ON_CONTENT_END: 'Close on Content End',
    SOUND_ON_HOVER: 'Sound on Hover',
    PLAY_ON_PERCENTAGE_VISIBILITY: 'Play on % Visibility',
    PAUSE_ON_PERCENTAGE_VISIBILITY: 'Pause on % Visibility',
    PAUSE_ON_HIDDEN_TAB: 'Pause on Hidden Tab',
    LOCATION: 'Location',
    OPERATING_SYSTEM: 'Operating System',
    SELECT_COUNTRY: 'Select Country',
    SELECT_AVOIDANCE: 'Select Avoidance',
    SELECT_TARGETING: 'Select Targeting',
    SELECT_HIGH_RISK: 'High Risk Categories',
    IAS_AVOIDANCE: 'IAS Avoidance',
    IAS_TARGETING: 'IAS Targeting',
    SELECT_DMA: 'Select DMA',
    DMA: 'DMA',
    STATE: 'State',
    STATES_DISABLED_TOOLTIP: 'Target United States as a country',
    SELECT_STATES: 'Select States',
    SELECT_SCHAIN: 'Select Schain',
    DMA_DISABLED_TOOLTIP: 'Target United States as a country',
    DMA_DISABLED_POPUP: 'Please either Include United States in your Country targeting or turn off DMA targeting',
    TARGETING_DMA_ERROR: 'Targeting DMA: List cannot be empty.',
    TARGETING_STATES_ERROR: 'Targeting State: List cannot be empty.',
    TARGETING_DAY_PARTING_ERROR: 'Targeting Day Parting: One or more settings are invalid.',
    TARGETING_DMA: 'Targeting DMA',
    TARGETING_STATES: 'Targeting States',
    CAPPING_USER_FREQ: 'User Frequency Capping',
    FREQUENCY: 'Frequency',
    CAPPING_IP_FREQ: 'IP Frequency Capping',
    DAY_PART: 'Day Parting',
    DAYPART_SELECT_DAY: 'Select Day',
    DAYPART_SELECT_STARTTIME: 'Start time',
    DAYPART_SELECT_ENDTIME: 'End time',
    TIME_TARGETING: 'Time Targeting',
    TIME_TARGETING_RTB_DX: 'Time Targeting for RTB and CedatoX Demands',
    ADD_DAY_PART: 'Add Day Part',
    SELECT_BROWSER: 'Select Browser',
    ENTER_VAST_DOMAIN: 'Enter VAST Domain',
    SELECT_OPERATING_SYSTEM: 'Select Operating System',
    SELECT_PLAYER_SIZE: 'Select Player Size',
    SUPPLY_TOOLTIP_ACTIVE:
      'Please note that deactivating a supply source breaks the connection with the associated demand. It does not stop traffic (opportunities) from being sent to Cedato. Please remember to discontinue traffic on the source platform as well.',
    SUPPLY_TOOLTIP_CONTROLBAR: 'Enables the display of the control bar on content.',
    SUPPLY_TOOLTIP_CONTROLBAR_DISABLED:
      'Enables the display of the control bar on content playback only. Please disable the checkbox ‘Control Bar’ under Supply > Settings to make this configuration available.',
    SUPPLY_TOOLTIP_POSTER_IMAGE:
      'The poster image url should support secure and non-secure traffic. We advise to use .jpeg, .png and .gif. file formats to avoid issues in serving.',
    SUPPLY_TOOLTIP_CONTENT_VIDEO:
      'The content video url should support secure and non-secure traffic. You can use several video files by entering each file URL in a new line. We advise to use .mp4 file format to avoid issues in serving.',
    SUPPLY_TOOLTIP_CONTENT_DESCRIPTION:
      'The video description is applied to all content configured in the ‘Content video’/ ‘Content image’ - URL fields. In case of more than one entered content URL it is advised to use content that can be summarized under the provided description. The provided description will be applied to all content (videos in the playlist/ image). The information entered into the provided description fields will be passed inside the correlating macros to find under Demand > Settings > view available macros.',
    SUPPLY_TOOLTIP_VAST_REQUEST_LIMIT:
      "This setting applies to each assigned Demand of this Supply. If the 'VAST Request Limit' on the Demand is set on a stricter limitation than on the Supply, then the stricter limitation will be applied.",
    TOOLTIP_TARGETING_PLAYERSIZE_WARNING: `The player size is targeted in size ranges and is depending on the placement area.<br><br><strong>Small:</strong> smaller than 300x250 or equivalent<br><strong>Medium:</strong> greater than 300x250 and smaller than 640x360<br><strong>Large:</strong> larger than 640x360 or equivalent<br><br>For further details click <a class="tooltipLink" href="https://cedato.zendesk.com/knowledge/articles/115001602173/en-us?brand_id=689021" target="_blank">here.</a>`,
    VENDOR_DOMAIN_NOT_VALID: 'One or more domains are not valid domains.',
    APP_BUNDLE_TARGETING: 'Block ad requests when the declared and detected App Bundles do not match',
    APP_BUNDLE_TARGETING_EDITABLE: 'Allow Edit of App Bundle/Domain detected-declared feature',
    DETECTED_DOMAIN_TARGETING: 'Block ad requests when the declared and detected domains do not match',
    DETECTED_DOMAIN_TARGETING_EDITABLE: 'Allow Edit of App Bundle/Domain detected-declared feature',
    VERSION: 'Version',
    BETWEEN: 'Between',
    AND: 'and',
    AUTOMATIC_REPORTS: 'Automatic Reports',
    EDIT_AUTOMATIC_REPORT: 'Edit Report',
    NEW_AUTOMATIC_REPORT: 'New Report',
    LATEST: 'Latest',
    CUSTOM: 'Custom',
    AD_MAX_LOADING_TIME: 'Ad Max Loading Time',
    CALLBACK_DELETED_SUCCESSFULLY: 'Callback deleted successfully',
    COPY_TO_CLIPBOARD: 'Copy to clipboard',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard',
    SUPPLY_CREATED_SUCCESSFULLY: 'Supply created successfully',
    SUPPLY_SAVED_SUCCESSFULLY: 'Supply saved successfully',
    ASSIGNED_SUPPLY: 'Assigned Supply',
    DEMAND_CREATED_SUCCESSFULLY: 'Demand created successfully',
    DEMAND_SAVED_SUCCESSFULLY: 'Demand saved successfully',
    DEMAND_NAME_IS_ALREADY_IN_USE: 'Demand name is already in use',
    ENTER_DEMAND_NAME: 'Enter Demand Name',
    CHANNEL_ID: 'Channel ID',
    DEMAND_TOOLTIP_PREMIUM:
      'Premium demand is given precedence over non-premium demand. Note that RPM may be affected.',
    JS_FLASH_PREFERENCE: 'JS/Flash Preference',
    AUTO: 'Auto',
    USE_FLASH_BY_DEFAULT: 'Use Flash by default',
    USE_JS_BY_DEFAULT: 'Use JS by default',
    USE_FLASH_ONLY: 'Use Flash only',
    USE_JS_ONLY: 'Use JS only',
    DEMAND_TOOLTIP_URL:
      'Be advised to replace the required macros with the corresponding and available macros from Cedato. Please be aware to remove unnecessary encoding text and to use only macros that are available in Cedato. A macro implementation has always this syntax: http://www.example.com?<strong>advparam=[CEDATO_MACRO]</strong>. Macros that are not replaced accordingly, will not pass the required information to the advertiser.',
    DEMAND_PARTNER_NAME: 'Demand Partner Name',
    DEAL_ID: 'Deal ID',
    ENTER_DEAL_ID: 'Enter Deal ID',
    DAILY_IMPRESSIONS: 'Daily Impressions',
    DAILY_AD_REQUESTS: 'Daily Ad Requests',
    USER_ID_CAPPING: 'User ID Frequency',
    IP: 'IP Frequency',
    ASAP: 'ASAP',
    EVEN: 'Even',
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
    HOURLY: 'Hourly',
    SUPPLY_COPIED_SUCCESSFULLY: 'Supply copied successfully',
    DEMAND_COPIED_SUCCESSFULLY: 'Demand copied successfully',
    MULTIFILTERS: 'Multifilters',
    NO_AVAILABLE_MULTIFILTERS: 'No available multifilters',
    ADD_DIMENSION: 'Add dimension',
    REPORT_SAVED_SUCCESSFULLY: 'Report saved successfully',
    REPORT_COPIED_SUCCESSFULLY: 'Report copied successfully',
    REPORT_CREATED_SUCCESSFULLY: 'Report created successfully',
    REPORT_DELETED_SUCCESSFULLY: 'Report deleted successfully',
    NETWORK_HAS_BEEN_CHANGED_SUCCESSFULLY: 'Network has been changed successfully',
    CEDATOX_MARKETPLACE: 'CedatoX Marketplace',
    TARGETED_TRAFFIC_SOURCE: 'Targeted traffic source',
    NO_PREFERENCE_SET_BY_DEMAND_PARTNER: 'No preference set by Demand Partner',
    REVENUE_TYPE: 'Revenue Type',
    DEMAND_PARTNER: 'Demand Partner',
    DEMAND_OWNER: 'Demand Owner',
    DEMAND_CACHE_TTL: 'Demand Cache Time to live',
    REACHED_CAPPING_SETTINGS: 'Reached Capping Setting',
    SHOW_DEMAND_STATUS: 'Show Demand Status',
    UNTITLED_LIST: 'Untitled List',
    CONDITION_TYPE: 'Condition Type',
    IP_ADDRESSES: 'IP Addresses',
    SCHAIN: 'Supply Chain',
    IPV4_RANGES: 'IPv4 Ranges',
    IPV6_RANGES: 'IPv6 Ranges',
    APPLE_ADVERTISING_ID: 'Apple Advertising ID (IDFA)',
    GOOGLE_ADVERTISING_ID: 'Google Advertising ID (AAID)',
    EFFECTIVE_FOR: 'Effective For',
    EFFECTIVE_FOR_ALL: 'Effective for All',
    PROTECTED_MEDIA: 'Protected Media',
    MOAT: 'Moat',
    QA_NETWORK: 'QA Network',
    REAL_NETWORK: 'Real Network',
    ARCHIVED: 'Archived',
    NETWORK_NAME_IS_REQUIRED: 'Network name is required',
    FINANCIAL_DETAILS: 'Financial Details',
    STARTING_DATE: 'Starting Date',
    CEDATO_ENTITY: 'Cedato Entity',
    MSA_ADDRESS: 'MSA Address',
    INC: 'Inc.',
    LTD: 'Ltd.',
    PRE_BID_PIXALATE: 'Pre-Bid by Pixalate',
    CX_ASSIGNED_DEMAND_CPM_WARNING: 'Demands with lower CPM than Supply cost are assigned',
    PRICING_DETAILS_US_MISSING_STATE: "You chose United States as the country, but didn't specify a state",
    LIST_NAME_IS_REQUIRED: 'List name is required',
    LIST_FILE_IS_REQUIRED: 'List file is required',
    FILE_SIZE_EXCEED_ERROR: (number: number) => `The file can\'t be bigger than ${number}MB`,
    EXCEEDED_MAX_CHARS_SIZE: (number: number) => `Max size is ${number}&nbsp;characters`,
    LIST_SAVED_SUCCESSFULLY: 'List saved successfully',
    LIST_SAVE_ERROR: 'No valid items have been found',
    LIST_IS_EMPTY_ERROR: 'A list must contain at least one item',
    NAME_ALREADY_EXISTS: 'Name already exists',
    IP_LISTS_REACH: 'IP lists limit was reached',
    LIST_DELETED_SUCCESSFULLY: 'List deleted successfully',
    BACKEND_VER: 'Backend version',
    FRONTEND_VER: 'Frontend version',
    NEW_PUBLISHER: 'New Publisher',
    EDIT_PUBLISHER: 'Edit Publisher',
    PUBLISHER_NOT_FOUND: 'Publisher not found',
    PUBLISHER_IO_NETWORK: 'Publisher IO',
    PLACEMENTS: 'Placements',
    SETTINGS_SAVED_SUCCESSFULLY: 'Settings saved successfully',
    NEW_AND_CONFIRM_PASSWORD_DONT_MATCH: "'New password' and 'Confirm new password' don't match",
    IS_REQUIRED: 'is required',
    IS_INVALID: 'is invalid',
    PREBID: 'Pre-Bid',
    POSTBID: 'Post-Bid',
    PREBID_ANONYMOUS_INFO: 'Filter Traffic from Anonymous IP Addresses',
    PREBID_FRAUD_INFO: 'Filter Suspicious Traffic (IP & IDFA/ADID list by Pixalate)',
    ALL_DEMANDS_WILL_FILTER: 'All Demands will filter invalid and high risk traffic',
    ALL_DEMANDS_WILL_NOT_FILTER: 'Only selected Demands will filter invalid and high risk traffic',
    PREBID_FRAUD_GLOBAL_TOOLTIP:
      'Suspicious Demand filter is turned on at the Network level and can’t be edited from here',
    ADDITIONAL_FEE_WILL_BE_APPLIED: 'Additional fee will be applied',
    POSTBID_INFO: 'Opt in Post-Bid Analysis',
    IMPRESSIONS_TO_SAMPLE: 'Impressions to Sample (%)',
    IMPS_TO_SAMPLE: 'Imps to Sample (%)',
    PROVIDER: 'Provider',
    INVALID_USERNAME: 'Username must be more than 2 symbols and less than 40',
    INVALID_PASSWORD: 'Your password must contain at least 8 characters. It must include at least one capital letter.',
    MISSING_PASSWORD: 'Password is required',
    USER_SAVED_SUCCESSFULLY: 'User saved successfully',
    DISABLED: 'Disabled',
    EMPTY: 'Empty',
    CANT_BE_EMPTY: "can't be empty",
    SHOW_ALL_NETWORKS: 'Show All Networks',
    DOMAIN_LIST: 'Domain List',
    IP_LIST: 'IP List',
    ALL_TRAFFIC_SOURCES: 'All traffic sources',
    TYPE_PARTNERS_NAME: "Type Partner's Name",
    CHOOSE_DEMAND_OWNER: 'Choose Demand Owner',
    TYPE_SUPPLY_NAME: 'Enter Supply Name',
    TYPE_DEMAND_NAME: 'Enter Demand Name',
    LOGGING_IN: 'Logging In',
    PREPARING_YOUR_WORK_ENVIRONMENT: 'Preparing your work environment',
    MILLION: 'Million',
    SWITCHING_TO: 'Switching to',
    PLAYER_READY: 'Player Ready',
    AD_START: 'Ad Start',
    AD_COMPLETE: 'Ad Complete',
    AD_CLICK: 'Ad Click',
    AD_IMPRESSIONS: 'AD Impressions',
    SUPPLY_OPPORTUNITIES: 'Supply Opportunities',
    DEMAND_OPPORTUNITIES: 'Demand Opportunities',
    SUPPLY_LOADED: 'Player Load',
    AD_Q1_PLAYED: '1st Quartile',
    AD_Q2_PLAYED: '2nd Quartile',
    AD_Q3_PLAYED: '3rd Quartile',
    AD_Q4_PLAYED: 'Completed',
    VCR: 'VCR',
    AD_CLICKED: 'Clicks',
    CONTENT_CLICKS: 'Content Clicks',
    AD_LOADED: 'Ad Load',
    AD_START_AVG_TIME: 'Ad start avg. time',
    AD_LOAD_AVG_TIME: 'Ad load avg. time',
    IVT_DETECTION: 'IVT Detection',
    EVENT: 'Event',
    NEW_ENTITY_GENERAL_ERROR: 'Some fields are missing or invalid',
    EMAIL_IS_MISSING: 'Email is missing',
    EMAIL_IS_INVALID: 'Email is invalid',
    ENTER_EMAIL: 'Enter Email',
    ENTER_USERNAME: 'Enter Username',
    ENTER_PASSWORD: 'Enter Password',
    ENTER_PUBLISHER_NAME: 'Enter Publisher Name',
    PUBLISHER_NAME_IS_REQUIRED: 'Publisher name is required',
    PUBLISHER_NAME_IS_TOO_LONG: 'Publisher name is too long',
    PUBLISHER_NAME: 'Publisher Name',
    ASSIGNED_PLACEMENT: 'Assigned Placement',
    PLACEMENT_ID: 'Placement ID',
    PLACEMENT_NAME: 'Placement Name',
    COST_CALCULATION: 'Cost Calculation',
    FIXED_COST: 'Fixed Cost ($)',
    REVSHARE_COST: 'Revshare Cost (%)',
    PUBLISHER_CREATED_SUCCESSFULLY: 'Publisher Created successfully',
    PUBLISHER_SAVED_SUCCESSFULLY: 'Publisher saved successfully',
    MISSING_OR_INVALID: 'missing or invalid',
    AVG_VIEWED_TIME: 'Avg. Viewed Time',
    HOVERED_IMPRESSIONS: 'Hovered Impressions %',
    AVG_TIME_UNTIL_HOVER: 'Avg. Time Until Hover',
    BTF_PERCENTAGE: 'BTF %',
    OOF_PERCENTAGE: 'Out of Focus %',
    PLAYER_LOADS_PERCENTAGE: 'Player Loads %',
    AD_RESPONSES: 'Ad Responses',
    AD_LOADS: 'Ad Loads',
    AD_LOADS_PERCENTAGE: 'Ad Loads %',
    START_REQUESTS: 'Start Requests',
    START_FILL_PERCENTAGE: 'Start Fill %',
    FIRST_QUARTILE: '1st Quartile',
    MIDPOINT: 'Midpoint',
    THIRD_QUARTILE: '3rd Quartile',
    COMPLETE: 'Complete',
    CLICKS: 'Clicks',
    IVT_MEASURABLE_PERCENTAGE: 'IVT Measurable %',
    IVT_MEASURABLE: 'IVT Measurable',
    IVT_PERCENTAGE: 'IVT %',
    GIVT_PERCENTAGE: 'GIVT %',
    SIVT_PERCENTAGE: 'SIVT %',
    ANALYZED_IMPRESSIONS: 'Analyzed Impressions',
    VIEWABILITY_ANALYZED: 'Viewability Analyzed',
    PROXY_TRAFFIC: 'Proxy Traffic',
    DATA_CENTER_TRAFFIC: 'Data Center Traffic',
    VIEWABILITY_PERCENTAGE: 'Viewability %',
    VIEWABILITY_MEASURABLE_PERCENTAGE: 'Viewability Measurable %',
    VIEWABILITY_MEASURABLE: 'Viewability Measurable',
    IN_VIEW_MEASURABLE_PERCENTAGE: 'InView Measurable %',
    MEASURABLE_IMPRESSIONS_PERCENTAGE: 'Measurable Impressions %',
    REACHED_COMPLETE_RATE_PERCENTAGE: 'Reached Complete Rate %',
    IVT_MEASURABLE_PERCENTAGE_TT:
      'IVT Measurable Rate %: The percentage of impressions analyzed where Moat was able to measure IVT metrics.',
    IVT_PERCENTAGE_TT:
      'IVT %: The percentage of total unfiltered impressions that were determined to be delivered to a non-human end point. This includes General IVT (Spiders, Excessive Activity, and/or Data Center Traffic categories) and Sophisticated IVT (Invalid Proxy, Automated Browser, and/or Incongruous Browser Traffic categories)',
    GIVT_PERCENTAGE_TT:
      'GIVT %: The percentage of sampled impressions that were determined to be delivered to a General IVT endpoint (Spiders, Excessive Activity, and/or Data Center Traffic categories',
    SIVT_PERCENTAGE_TT:
      'SIVT %: The percentage of sampled impressions that were determined to be delivered to a Sophisticated IVT endpoint (Invalid Proxy, Automated Browser, and/or Incongruous Browser Traffic categories)',
    IVT: 'IVT',
    ANALYZED_IMPRESSIONS_TT:
      'Analyzed Impressions: The number of impressions tracked and filtered for General and Sophisticated Invalid Traffic.',
    MEASURABLE_IMPRESSIONS_PERCENTAGE_TT:
      'Measurable Impressions %: The number of impressions where viewability was measurable divided by the number of Impressions Analyzed.',
    REACHED_COMPLETE_RATE_PERCENTAGE_TT:
      'Reached Complete Rate %: The percentage of measurable impressions where the ad played to completion (regardless of viewability)',
    SAMPLED_IMPRESSIONS_TT_QUALITY: 'Sampled Impressions: The number of impressions that were sampled by Moat.',
    OPPORTUNITIES_TT: 'Opportunities: Amount of received ad impression events',
    BACKGROUND_BOX_HEIGHT: 'Background Box Height',
    BACKGROUND_BOX_COLOR: 'Background Box Color',
    PERSISTENT_PLAYER_SIZE: 'Persistent Player Size',
    PERSISTENT_PLAYER_LOCATION: 'Persistent Player Location',
    FROM_THE: 'from the',
    TOP: 'Top',
    BOTTOM: 'Bottom',
    LEFT: 'Left',
    RIGHT: 'Right',
    PERSISTENT_PLAYER_PADDING: 'Persistent Player Padding',
    RATIO_IS_MISSING: 'Ratio is required, and must be at least 0.01',
    PLAY_ON_VISIBILITY_MUST_BE_LARGER_THAN_PAUSE_ON_VISIBILITY:
      'Play on % Visibility must be larger than Pause on % Visibility',
    PLAY_OR_PAUSE_ON_VISIBILITY_ARE_INVALID: 'Play and Pause on Visibility are required, and must be between 1 and 100',
    PERSISTENT_LOCATION_INVALID_X: 'Persistent location X is required, and must be a positive number',
    PERSISTENT_LOCATION_INVALID_Y: 'Persistent location Y is required, and must be a positive number',
    PERSISTENT_LOCATION_PADDING: 'Persistent padding is required, and must be a positive number',
    PRETTY_PRINT: 'Pretty Print',
    PLEASE_ASSIGN_AT_LEAST_ONE_PLACEMENT: 'Please assign at least one placement',
    PLACEMENT_REMOVAL_CONFIRMATION_HEADER: 'Placement removal',
    PLACEMENT_REMOVAL_CONFIRMATION_TEXT: 'Are you sure you want to remove this placement?',
    PLACEMENT_REMOVED_SUCCESSFULLY: 'Placement removed successfully',
    OVERRIDE_REPORT_NAME_CONFIRM: 'already exists. Do you want to override it?',
    REPORT_TOOLTIP_C: 'Cost: Calculation of cost based on settings in Supply > Settings > Supply Cost Type',
    REPORT_TOOLTIP_A: 'Ad Requests: Number of times Cedato called the Demand tag URL',
    REPORT_TOOLTIP_I: 'Impressions: Amount of received ad impression events',
    REPORT_TOOLTIP_R:
      'Revenue: Revenue generated by ads that started playing (Impressions), according to the CPM set in Cedato',
    REPORT_TOOLTIP_P: 'Impression RPM: Revenue per 1000<br/>impressions (Revenue/Impressions*1000)',
    REPORT_TOOLTIP_O:
      'Opportunities: Amount of calls from the media source to load the Cedato Supply tag, as received by Cedato',
    REPORT_TOOLTIP_M: 'RPM: Revenue per 1000 opportunities (Revenue/Opportunities*1000)',
    REPORT_TOOLTIP_F: 'Fill Rate: Impressions/Opportunities*100',
    REPORT_TOOLTIP_D: 'Demand Fill Rate %: Impressions/Ad Requests*100',
    REPORT_TOOLTIP_SOP:
      'Supply Opportunities: Amount of calls from the media source to load the Cedato Supply tag, as received by Cedato',
    REPORT_TOOLTIP_DOP:
      'Demand Opportunities: Amount of calls from the media source to load the Cedato Supply tag, as received by Cedato',
    REPORT_TOOLTIP_SLD: 'Player Loads: Amount of times the player was fully loaded on a media source.',
    REPORT_TOOLTIP_I_DEMAND: 'Impressions: Amount of ad impression events received by Cedato',
    REPORT_TOOLTIP_R_DEMAND:
      'Revenue: Revenue generated by ads that started playing (Impressions), according to the CPM set in Cedato',
    REPORT_TOOLTIP_P_DEMAND:
      'Impression RPM: CPM of the played Demand as set in Demand > Settings > CPM or Supply > Assigned Demand > CPM',
    REPORT_TOOLTIP_PQ1: '1st Quartile: The amount of impressions that played at least 25% of the ad',
    REPORT_TOOLTIP_PQ2: 'Midpoint: The amount of impressions that played at least 50% of the ad',
    REPORT_TOOLTIP_PQ3: '3rd Quartile: The amount of impressions that played at least 75% of the ad',
    REPORT_TOOLTIP_PQ4: 'Complete: The amount of impressions that played the ad fully',
    REPORT_TOOLTIP_VCR: 'Video Ad Completion Rate',
    REPORT_TOOLTIP_CLK: 'Clicks: Amount of times user clicked on the Ad',
    REPORT_TOOLTIP_CCL: 'Content clicks: The amount of content clicks',
    REPORT_TOOLTIP_CVW: 'Content View: The amount of content videos that have been started',
    REPORT_TOOLTIP_CCD: 'Content Completed: The amount of content videos that have been played fully',
    REPORT_TOOLTIP_ADL: 'Ad Loaded: Number of adLoad events received',
    REPORT_TOOLTIP_AST: 'Ad start avg. time: The average time between the start requests to the Ad start',
    REPORT_TOOLTIP_ALT: 'Ad load avg. time: The average time between the init to the Ad load',
    REPORT_TOOLTIP_SRQ: 'Start Requests: ???',
    REPORT_TOOLTIP_PRV: 'First Preview: ???',
    REPORT_TOOLTIP_TPR: 'Total Previews: ???',
    REPORT_TOOLTIP_DCS: 'Demand Cost: The Supply Cost reflected on the Demand item',
    REPORT_TOOLTIP_VWY: 'Viewability',
    REPORT_TOOLTIP_VWS: 'Viewability Sampled',
    CONTENT_ID: 'Content ID',
    CONTENT_NAME: 'Content Name',
    VI_VIEW_1_TT:
      'Viewed 1s%: The number of impressions where the ad played for at least one continuous second with at least 50% of the player visible on-screen and the page in-focus divided by the number of Measurable Impressions',
    VI_VIEW_2_TT:
      'Viewed 2s%: The number of impressions where the ad played for at least two continuous seconds with at least 50% of the player visible on-screen and the page in-focus divided by the number of Measurable Impressions',
    VI_VIEW_5_TT:
      'Viewed 5s%: The number of impressions where the ad played for at least five continuous seconds with at least 50% of the player visible on-screen and the page in-focus divided by the number of Measurable Impressions',
    VI_VIEW_15_TT:
      'Viewed 15s%: The number of impressions where the ad played for at least fifteen continuous seconds with at least 50% of the player visible on-screen and the page in-focus divided by the number of Measurable Impressions',
    VI_VIEW_25_TT:
      'Viewed 25s%: The number of impressions where the ad played for at least twenty five continuous seconds with at least 50% of the player visible on-screen and the page in-focus divided by the number of Measurable Impressions',
    VI_VIEW_UNDETER_TT: 'Undetermined: Amount of traffic in % where the viewability could not be measured',
    VIEWABILITY_TT: 'At least 50% of the ad pixels were shown in the 1st second of the ad',
    VIDEO_IN_VIEW_TIME_TT:
      'Video in view time: The average time in seconds that the ad was visible for users who met the requirement for a Viewed 1 sec',
    HOVERS_PERCENT_TT:
      'Hovered Impressions %: The percentage of impressions where the user hovered on the player while the ad was playing',
    HOVERS_PERCENTAGE: 'Hover %',
    HOVERS: 'Hover',
    PREVIEWED: 'First Preview',
    PREVIEWS: 'Total Previews',
    OLD_BROWSER: 'Old Browser',
    SAMPLED_IMPRESSIONS_TT: 'Sampled Impressions: Amount of Impressions that were sampled',
    PLAYER_LOADS_TT: 'Player Loads: Amount of times the player was fully loaded on a media source.',
    PLAYER_LOADS_PERCENTAGE_TT:
      'Player Loads%: Amount of times the Player was fully loaded on a media source/Opportunities*100',
    PLAYER_LOADS_PERCENTAGE_TT_2: 'Player Loads%: Player Loads/Opportunities*100',
    IMPRESSIONS_TT: 'Impressions: Amount of received Ad Impression events from the sampled Demand',
    IMPRESSIONS_TT_2: 'Impressions: Amount of Ad Impression events received by Cedato',
    IMPRESSION_RPM_TT: 'CPM of the played Demand as set in Demand > Settings > CPM or Supply > Assigned Demand > CPM.',
    FILLRATE_TT: 'Fill Rate %: Impressions/Ad Responses*100',
    TIME_TO_HOVER_TT:
      'Avg. Time until Hover: The average amount of time until the user hovered on the player, measured from the start of the ad',
    BTF_TT:
      'Below the Fold %: Percentage of impressions where more than half of the ad loaded below the fold. The fold is defined as 750 px',
    OUT_OF_FOCUS_TT:
      'Out of Focus %: Percentage of impressions where the tab containing the ad was never brought into foreground',
    IN_VIEW_MEASURABE_TT:
      'The number of impressions where viewability was measurable divided by the number of Impressions Analyzed',
    SUSP_MEASURABLE_TT:
      'IVT Measurable Rate %: The percentage of impressions analyzed where Moat was able to measure IVT metrics',
    SUSP_BOT_TT:
      'IVT Rate %: The percentage of total unfiltered impressions that were determined to be delivered to a non-human end point. This includes General IVT (Spiders, Excessive Activity, and/or Data Center Traffic categories) and Sophisticated IVT (Invalid Proxy, Automated Browser, and/or Incongruous Browser Traffic categories)',
    REACHED_COMPLETE_TT:
      'Reached Complete Rate %: The percentage of measurable impressions where the ad played to completion (regardless of viewability)',
    AF_FRAUD_TT:
      'High Risk%: High Risk identification covers a complete range of fraudulent traffic sources such as; bot activities, viruses, tunneled traffic, hostile tools, viewer fraud and more',
    AF_SUSP_TT:
      'Suspect%: This traffic is not identified as High Risk but require monitoring and further investigation',
    AD_RESPONSES_TT: 'Ad Responses: Number of successful (non-empty) responses from the Demand partner.',
    AD_LOADS_TT:
      'Ad Loads: Number of times the Demand responded that it has a valid media file and it is ready to play.',
    AD_LOADS_PERCENTAGE_TT: 'Ad Loads%: Ad Loads/Ad Responses*100.',
    START_REQUESTS_TT: 'Start Requests: Number of times Cedato requested Demand to start playing.',
    START_FILL_PERCENTAGE_TT: 'Start Fill%: Impressions/Start Requests*100.',
    FIRST_QUARTILE_TT: '1st Quartile: How many times 25% of the ad was played.',
    MIDPOINT_TT: 'Midpoint: How many times 50% of the ad was played.',
    THIRD_QUARTILE_TT: '3rd Quartile: How many times 75% of the ad was played.',
    COMPLETE_TT: 'Complete: How many times 100% of the ad was played.',
    CLICKS_TT: 'Clicks: Amount of times user clicked on the ad.',
    AD_REQUESTS_TT: "Ad Requests: Number of times Cedato called the Demand tag URL.'",
    VIEW_ALL: 'View All',
    VIEW_ELIGIBLE: 'View Eligible',
    VIEW_AVAILABLE: 'View Available',
    VIEW_INELIGIBLE: 'View Ineligible',
    VIEW_UNAVAILABLE: 'View Unavailable',
    ELIGIBLE: 'eligible',
    INELIGIBLE: 'ineligible',
    DEFAULT_CPM: 'Default CPM',
    OVERRIDE_CPM_WARNING: 'Overriding default CPM',
    LOWER_CPM_WARNING: 'Demand with lower CPM than Supply cost',
    SAP_NO: 'SAP No.',
    SORT_NO: 'Sort No.',
    FINANCE_COMMENTS: 'Finance Comments',
    SAP_NO_IS_REQUIRED: 'Sap No. is missing',
    SORT_NO_IS_REQUIRED: 'Sort No. is missing',
    FINANCE_EDIT_SUCCESS: 'Finance details were saved successfully',
    TO_BILL: 'To Bill',
    OK_CSM: 'OK CSM',
    CSM_COMMENTS: 'CSM Comments',
    FINANCE_FINAL: 'Finance Final',
    PREPAYMENT: 'Prepayment',
    CHECK: 'Check',
    CSM: 'CSM',
    DELETE_NETWORK_INFO1: 'You are about to delete ',
    DELETE_NETWORK_INFO2:
      '<b>This action cannot be undone.</b> This action will delete the network itself, its supplies, demands, lists, etc...',
    DELETE_NETWORK_INFO3: 'Please type in the name of the network to confirm.',
    DELETE_NETWORK_NAME_ERROR: "Network name doesn't match",
    NETWORK_CREATED_SUCCESSFULLY: 'Network created successfully',
    NETWORK_UPDATED_SUCCESSFULLY: 'Network updated successfully',
    NETWORK_DELETED_SUCCESSFULLY: 'Network deleted successfully',
    I_CONFIRM_DELETE_THIS_NETWORK: 'I confirm, delete this network',
    PLAYER_LOCATION: 'Player Location',
    PLAYER_PADDING: 'Player Padding',
    PLAY_AD: 'Play Ad',
    FIRST_AD_WILL_PLAY_AFTER: 'First Ad Will Play After',
    MIDROLL_TIME_INTERVAL: 'Mid Roll Time Interval',
    ALLOWED_DELAY_FOR_PLAYING_THE_AD: 'Allowed Delay for Playing The Ad',
    FILTER_IVT: 'Filter IVT',
    MANAGE_SUPPLY_NO_DATA: 'You currently have no supplies.<br/>Start by creating your first supply.',
    MANAGE_DEMAND_NO_DATA: 'You currently have no demands.<br/>Start by creating your first demand.',
    MANAGE_LISTS_NO_DATA: 'You currently have no lists.<br/>Start by creating your first list.',
    COPY_URL: 'Copy URL',
    SELECTED_ITEMS: 'selected items',
    LOADING: 'Loading',
    SELECTED: 'Selected',
    NOT_SELECTED: 'Not selected',
    VIEWABILITY_GOAL: 'Viewability Goal',
    VIEWABILITY_RESTRICTION_LABEL: 'Receive requests from Traffic Source with Viewability greater than:',
    VIEWABILITY_PASS: "Pass requests in case there's not enough information regarding Viewability.",
    VIEWABILITY_BLOCK: "Block requests in case there's not enough information regarding Viewability.",
    MESSAGE_SAVED_AS_DRAFT_SUCCESSFULLY: 'Message saved as a draft successfully',
    MESSAGE_PUBLISHED_SUCCESSFULLY: 'Message published successfully',
    MESSAGE_DISMISSED_SUCCESSFULLY: 'Message dismissed successfully',
    BID_REQUESTS: 'Bid Requests',
    RTB_BID_REQUESTS: 'Bid requests',
    BID_RESPONSES: 'Bid Responses',
    RTB_BID_RESPONSES: 'Bid responses',
    NO_BID_RESPONSES: 'No-Bid Responses',
    RTB_NO_BID_RESPONSES: 'No bid response',
    BID_CPM: 'Bid CPM',
    RTB_BID_CPM: 'Bid CPM',
    RTB_DEMAND: 'RTB Demand',
    SEARCH_QUERY_ERROR_MINIMUM: 'Please type at least 3 characters, and at least one letter/number.',
    SEARCH_QUERY_ERROR_BACKSLASH: "The '\\' character is not allowed.",
    SEARCH_QUERY_ERROR_BOTH:
      "Please type at least 3 characters, and at least one letter/number. The '\\' character is not allowed.",
    FILENAME_ERROR: `A file name can't contain these characters:<br/>\\ / : * ? " < > |`,
    DUPLICATE: 'Duplicate',
    DUPLICATE_SUPPLY: 'Duplicate Supply',
    DUPLICATE_DEMAND: 'Duplicate Demand',
    COPY_OF: 'Copy of ',
    RTB_PARTNER: 'RTB Partner',
    PAYMENT_DUE: 'Payment Due',
    PAYMENT_MESSAGE_1: `Your Cedato payment is past due. Please submit your payment or contact `,
    PAYMENT_MESSAGE_2: ` to settle the invoice.`,
    PASSED: 'Passed',
    NOT_PASSED: 'Not passed',
    DOMAIN_WHITELIST: 'Domain Whitelist',
    PREBID_URL_PAGE: 'Global Prebid URL',
    LIMIT_TO_ONE_IMPRESSION_PER_OPPORTUNITY: 'Limit to One Impression per Opportunity',
    NO_SELECTED_ITEMS: 'No Selected Items',
    FILTER_DIMENSION: 'Filter dimension',
    PARTNERS_EDIT: 'Partners Edit',
    PARTNERS_REPORT: 'Partners Report',
    PARTNERS_REPORT_BREAKDOWN: 'Break down by Partner',
    INCORRECT_USERNAME_OR_PASSWORD: 'Incorrect Username or Password',
    NO_NETWORKS_FOUND: 'No networks found',
    ALL_OPTIONS: 'All Options',
    SUPPLY_BY_DEMAND_SOURCES: 'Supply by Demand Sources',
    DEMAND_SOURCES_BY_SUPPLY: 'Demand Sources by Supply',
    SUB_ID_HINT_TOOLTIP: 'Enter one or more SubIDs in the<br/>following format (comma delimited): sid1,sid2,sid3',
    ADMIN_ALL_SUPPLY: 'Admin All Supply',
    ADMIN_ALL_DEMAND: 'Admin All Demand',
    ABOVE: 'Above',
    BELOW: 'Below',
    IVT_GOAL: 'IVT Goal',
    IVT_TARGETING_ITEMS: 'IVT Targeting Items',
    IVT_TARGETING_INFO:
      'Please opt-in to Post-bid service in order to target according to an IVT Goal. A minimum sampling rate of %10 is mandatory.',
    ADD_A_LIST: 'Add a List',
    DOWNLOAD_LIST: 'Download List',
    DELETE_LIST: 'Delete List',
    LIST_DELETE_CONFIRM: 'Are you sure you want to delete this list?',
    NO_VALID_LIST_ITEMS: 'All of the Domains/IPs were found to be invalid. Please upload a new list.',
    GDPR_MESSAGE_1: 'Please click ',
    GDPR_MESSAGE_2: " to review Cedato's updated policies and DPA",
    CEDATO_DPA: 'Cedato DPA',
    GDPR_INFO_TITLE: 'Dear Partner',
    GDPR_INFO_TEXT_1: `As well known, the European Union’s General Data Protection Regulation ("GDPR") came into effect on May 25, 2018. Consistent with Cedato’s commitment to privacy compliance and consumer protection, Cedato has developed and implemented a GDPR compliance program. In order to ensure Cedato’s contractual agreements, engagements and operation complies with the GDPR, Cedato has drafted the Cedato Data Processing Agreement ("DPA") which is govern the Processing of Personal Data (as defined under the GDPR) which constitutes an integral part of the applicable MSA signed between you and Cedato. The Cedato DPA is executed by Cedato, you are hereby requested to countersign the DPA. Note that, in the event you will not provide Cedato with a written notification explicitly stating otherwise, by continued use of the Cedato Services you confirm your acceptance of this `,
    GDPR_INFO_TEXT_2: ` and our updated online `,
    GDPR_INFO_TEXT_3: ` as of May 25, 2018. If you are accepting the DPA and the updated Terms on behalf of a company (or applicable entity), you represent and warrant that you have full legal authority to bind the company and provide acceptance on its behalf.`,
    DPA: `DPA`,
    TERMS_AND_CONDITIONS: `Terms and Conditions`,
    I_HAVE_READ_DPA: "I have read the DPA and I'm authorized to agree and accept the terms ",
    GDPR_ACCEPT: 'Accept Cedato DPA',
    PLEASE_CHECK_THE_BOX: 'Please check the agreement box',
    PLEASE_ENTER_YOUR_NAME: 'Please enter your name.',
    SEC: 'Sec.',
    ENTER_SUB_ID: 'Enter Sub ID',
    SUPPLY_PLATFORM: 'Supply Platform',
    CHECK_TO_ASSIGN_ALL: 'Check to assign all',
    UNCHECK_TO_UNASSIGN_ALL: 'Uncheck to unassign all',
    POSTBID_OPT_OUT_TITLE: 'Opting-out Post-Bid Services',
    POSTBID_OPT_OUT_INFO:
      'By opting-out from our Post-Bid services, targeting by Viewability and IVT goal will be disabled.<br/><br/>If you wish to remain opt-in and maintain the targeting by Viewability and IVT goal services please click Cancel.',
    POST_BID_FOR_PUBLISHERS: 'Post-Bid for Publishers',
    OPT_OUT: 'Opt-out',
    DEVELOPER_TOOLS: 'Developer Tools',
    USE_F_EVENTS2: 'Use `f_events2` table for Cedato Labs',
    USE_CACHE_TABLES: 'Use cache table for Cedato Labs',
    QUALITY_AND_VIEWABILITY_REMARK: '** Data is updated once an hour with a 2 hours delay',
    PREBID_SETTINGS_SAVED_SUCCESSFULLY: 'Pre-Bid settings saved successfully',
    POSTBID_SETTINGS_SAVED_SUCCESSFULLY: 'Post-Bid settings saved successfully',
    NETWORK_CALLBACKS_SAVED_SUCCESSFULLY: 'Network callbacks saved successfully',
    CHANGE_REPORT_TIME_ZONE: 'Change Report Time Zone',
    TIMEZONE_CHANGED_SUCCESSFULLY: 'Time zone changed successfully',
    CLICK_TO_ACTIVATE_SUPPLY: 'Click to activate the supply',
    CLICK_TO_DEACTIVATE_SUPPLY: 'Click to deactivate the supply',
    CLICK_TO_ACTIVATE_DEMAND: 'Click to activate the demand',
    CLICK_TO_DEACTIVATE_DEMAND: 'Click to deactivate the demand',
    CONFIRM_SELECT_ALL_SUPPLY: 'Are you sure you want to select all the chosen Supply items?',
    CONFIRM_UNSELECT_ALL_SUPPLY: 'Are you sure you want to unselect all the chosen Supply items?',
    CONFIRM_SELECT_ALL_DEMAND: 'Are you sure you want to select all the chosen Demand items?',
    CONFIRM_UNSELECT_ALL_DEMAND: 'Are you sure you want to unselect all the chosen Demand?',
    CONFIRM_SELECT_ALL_ITEMS: 'Are you sure you want to select all the chosen items?',
    CONFIRM_UNSELECT_ALL_ITEMS: 'Are you sure you want to unselect all the chosen items?',
    DEFAULT_TIMEZONE: 'EST (GMT-05:00)',
    MOAT_IMPS: 'Moat Imps',
    MOAT_CPM: 'Moat CPM',
    POSTBID_FEE: 'Post-Bid Fee',
    ABOUT_TO_SWITCH_NETWORK:
      "You've switched networks in another tab. In your next action, the new network will be set in this tab as well.",
    FEATURE_FLAGS: 'Feature Flags',
    FF_CDN_TOOLTIP: 'CDN Usage and Manage pages',
    // PRE_ROLL_ONLY: 'Pre-roll Only',
    FF_PREMIUM_VAST: 'Premium Demand',
    FF_PREMIUM_VAST_TOOLTIP: 'Premium Demand Toggler',
    FF_QUALITY_PLAYER_BY_DOMAIN: 'Supply by Domain Q&V Report',
    FF_QUALITY_PLAYER_BY_DOMAIN_TOOLTIP: 'Supply by Domain Quality and Viewability Report',
    FF_SUPPLYX_CAPPING: 'SupplyX Capping',
    FF_DEMANDX_CAPPING: 'DemandX Capping',
    FF_SUPPLYX_CAPPING_TOOLTIP: 'SupplyX Capping',
    FF_DEMANDX_CAPPING_TOOLTIP: 'DemandX Capping',
    FF_VENDOR_BLACKLIST: 'Vendor Blacklist',
    FF_VENDOR_BLACKLIST_TOOLTIP: 'Vendor Blacklist',
    FF_CEDATOX_DEMANDS_COUNT: 'CedatoX Demands Count',
    FF_CEDATOX_DEMANDS_COUNT_TOOLTIP: 'CedatoX Demands Count',
    FF_DYNAMIC_DEMAND: 'Dynamic Demand',
    ML_SCORING: 'ML Powered Scoring',
    ML_SCORING_TOOLTIP: 'Enable ML Powered Scoring algo',
    PREBID_SERVER_DEMAND: 'Prebid Server Demand',
    PREBID_SERVER_DEMAND_TOOLTIP: 'Enable Prebid Server Demand',
    FF_TAM_DEMAND: 'TAM Demand',
    FF_BOOST_DEMAND: 'Boost Demand',
    FF_BOOST_DEMAND_TOOLTIP: 'Boost Demand',
    ALL_NETWORKS: 'All Networks',
    TURN_ON_FOR_ALL_NETWORKS: 'Turn On for All Networks',
    TURN_OFF_FOR_ALL_NETWORKS: 'Turn Off for All Networks',
    SAVE_AS_DEFAULT_VALUE: 'Save Value as Default',
    SELECT_A_FEATURE_FLAG: 'Select a Feature Flag...',
    EXPERIMENTAL_FEATURES: 'Experimental Features',
    IVT_BLOCK: 'IVT Block',
    REQUIRE_VIEWABILITY: 'Require Viewability',
    DO_NOT_SEND_SCHAIN: 'Do not send Schain value',
    DYNAMIC_SCHAIN_NOTICE_LINE_1: 'Note: Conflicting <b>Prebid Schain</b> settings may prevent Dynamic Schain from activating',
    DYNAMIC_SCHAIN_NOTICE_LINE_2: 'correctly. Please <b>clear</b> any hardcoded Schain configurations prior to enabling the',
    DYNAMIC_SCHAIN_NOTICE_LINE_3: 'Dynamic Schain feature.',
    SKIP_NEXT_ADS_IN_SLOT: 'Skip next ads in the same slot',
    ADD_WHITELISTED_DOMAIN: 'Add a Whitelisted Domain',
    MANAGE_GLOBAL_PREBID_URL: 'Manage global prebid URL',
    TYPE_VENDOR_NAME: "Type vendor's name",
    DOMAIN_ALREADY_EXISTS: 'This domain already exists',
    LIMITED_ASSIGNMENT: 'Limited Assignment',
    HB_TYPE: 'HB',
    MEASURES_FILTER: 'Measures Filter',
    JSON_MISCONFIGURED:
      "The configuration has been changed, <a class='reset-json-config'>reset</a> the configuration to enable edit",
    PLAYER_VERSION: 'Player Version',
    SUPPLY_IS_LOCKED_FOR_DEMAND_ASSIGNMENT: 'Supply is limited for Demand assignment',
    DEMAND_IS_LOCKED_FOR_SUPPLY_ASSIGNMENT: 'Demand is limited for Supply assignment',
    ALLOW_TO_ASSIGN_LIMITED_ASSIGNMENT_SUPPLY: 'Allow to Assign Limited Assignment Supply',
    ALLOW_TO_ASSIGN_LIMITED_ASSIGNMENT_DEMAND: 'Allow to Assign Limited Assignment Demand',
    SUPPLY_IS_LIMITED_FOR_ASSIGNMENT: 'Supply is limited for assignment',
    DEMAND_IS_LIMITED_FOR_ASSIGNMENT: 'Demand is limited for assignment',
    DEMAND_PRICE_FACTOR: 'Demand partner % share of revenue',
    CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_1: 'This',
    CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_2: 'has',
    CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_3: 'assigned',
    CONFIRM_LIMIT_ASSIGN_MODAL_TEXT_4: "Clicking 'Confirm' will unassign these",
    LIMITS_NO_CREATE_MSG: (str: string) => `You have reached the maximum amount of allowed ${str} items.`,
    LIMITS_NO_SAVE_MSG: (str: string) =>
      `The ${str} item can not be saved, please make sure you haven’t exceeded the maximum amount of allowed active ${str} items.`,
    DUPLICATE_CEDATOX: 'Duplicate CedatoX',
    CONTENT_REPORTS: 'Content Reports',
    CONTENT_VIEWED: 'Content Views',
    CONTENT_COMPLETED: 'Content Completed',
    USE_LEAN_LIST: 'Use Lean List',
    PREBID_SUBCONFIG: 'Configuration',
    SELECT_ADAPTER_NAME: 'Select Adapter',
    EVENTS_V2_DISABLE_DEFAULT_PROBABILITY: 'Disable Default Events Probability',
    EVENTS_V2_DISABLE_DEFAULT_LOW_PRIORITY_PROBABILITY: 'Disable Default Events Low Priority Probability',
    NO_ITEMS_ASSIGNED_TO_REPORT: 'Assign at least one item to the report',
    GOOGLE_DEMAND: 'Google Demand',
    GOOGLE_KEY_VALUE: 'Key Value based tag',
    GOOGLE_KEY_VALUE_PARAM: 'Key Value Parameter',
    INTENT_DEMAND: 'Intent Demand',
    ALLOW_S2S_CALLS: 'Allow Server to Server calls',
    DEMAND_SEGMENTATION: 'Demand Segmentation',
    RPM_CLIENT_TRANSFER: 'RPM Client Transfer',
    LAST_RUN_DATE: 'Last Run Date',
    ITEM_ID: 'Item ID',
    ITEM_NAME: 'Item Name',
    PUBLISHER_HB: 'HB Supply Publisher User',
    CX_2_CX: 'Cx2Cx',
    CX_2_CX_TOOLTIP: 'Allows assign CedatoX to CedatoX items',
    LABS_V2: 'Events V2 Reports',
    LABS_V2_LEGACY_MEASURES: 'Events V2 Legacy Measures',
    LABS_V2_INTENT_MEASURES: 'Events V2 Intent Measures',
    LABS_V2_DEBUG_MEASURES: 'Events V2 Debug Measures',

    CAMPAIGN: 'Campaign',
    RUNNING_CAMPAIGN: 'Running Campaign',
    MANAGE_CAMPAIGNS: 'Manage Campaigns',
    NEW_CAMPAIGN: 'New Campaign',
    EDIT_CAMPAIGN: 'Edit Campaign',
    CAMPAIGN_ID: 'Campaign ID',
    CAMPAIGN_NAME: 'Campaign Name',
    ENTER_CAMPAIGN_NAME: 'Enter Campaign Name',
    CAMPAIGN_SAVED_SUCCESSFULLY: 'Campaign Saved Successfully',
    CAMPAIGN_CREATED_SUCCESSFULLY: 'Campaign Created Successfully',
    CAMPAIGN_NOT_FOUND: 'Campaign is not found',
    IS_RUNNING: 'Running',
    NOT_RUNNING: 'Not Running',
    LIVE: 'Live',
    NOT_LIVE: 'Not Live',
    START_DATE: 'Start Date',
    START_DATE_WRONG: 'Start Date should be earlier than End Date',
    END_DATE_WRONG: "End Date shouldn't be earlier than Start Date",
    END_DATE: 'End Date',
    CAMPAIGN_NAME_ERROR: "Campaign Name: Can't be empty",
    DAILY_BUDGET: 'Daily Budget',
    DAILY_BUDGET_ERROR: "Daily Budget: Can't be empty",
    HOURLY_BUDGET: 'Hourly Budget',
    HOURLY_BUDGET_ERROR: "Hourly Budget: Can't be empty",
    COMMON_BUDGET_ERROR: 'Hourly or Daily Budget should be set',
    BUDGET_COMPARE_ERROR: 'Daily Budget should be larger than Hourly',
    ASSIGNMENT_TYPE: 'Assignment Type',
    CAMPAIGN_NAME_DUPLICATED: 'Campaign with such Name already exists',
    DAILY_MIN_BUDGET_ERROR: (str: string) => `Daily Budget can remain empty or with the minimum value of ${str}`,
    HOURLY_MIN_BUDGET_ERROR: (str: string) => `Hourly Budget can remain empty or with the minimum value of ${str}`,
    ASSIGNED_CAMPAIGNS: 'Assigned Campaigns',
    SELECT_START_DATE: 'Select the Start Date',
    SELECT_END_DATE: 'Select the End Date',
    CAMPAIGN_TOOLTIP: 'Item is associated to at least 1 Campaign',
    RUNNING_CAMPAIGN_TOOLTIP: 'Item is associated to a current running Campaign',
    SUPPLY_METHOD: 'Supply Method',
    FIRST_AD_SLOT: 'First Ad Slot',
    DEMAND_FIRST_AD_SLOT: 'First Ad Slot for Demand',
    ENVIRONMENT_CTV: 'CTV Environment',
    NETWORK_PREBID_BUNDLE: 'Network Prebid Bundle',
    PREBID_BUNDLE: 'Prebid Bundle',
    PREBID_BUNDLE_URL: 'Prebid Bundle URL (loaded to Cedato CDN)',
    PREBID_BUNDLE_SAVED_SUCCESSFULLY: 'Prebid Bundle Saved Successfully',
    PREBID_JSON: 'Prebid Configuration JSON',
    NOT_SUPPORTED: 'Is not supported',
    INCORRECt_JSON_TEMPLATE: 'Incorrect JSON template.',

    // RTB PARTNERS
    MANAGE_RTB_PARTNERS: 'Manage RTB Partners',
    RTB_PARTNER_SELECT_PLACEHOLDER: 'Please choose Provider',
    RTB_ENDPOINTS: 'RTB Endpoints',
    RTB_PROVIDER: 'RTB Provider',
    ENDPOINT: 'Endpoint',
    ENDPOINT_URL: 'Endpoint URL',
    ENDPOINT_US_EAST: 'US East Endpoint',
    ENDPOINT_US_WEST: 'US West Endpoint',
    ENDPOINT_EXPAND_OPTIONS: 'Show additional endpoint options',
    JSON_CONFIG: 'JSON Config',
    NEW_RTB_PARTNER: 'Add new RTB Partner',
    RTB_PARTNER_NOT_FOUND: 'RTB Partner Not Found',
    RTB_PARTNER_SAVED_SUCCESSFULLY: 'RTB Partner Saved Successfully',
    RTB_PARTNER_CREATED_SUCCESSFULLY: 'RTB Partner Created Successfully',
    RTB_PARTNER_NAME_ERROR: 'RTB Partner Name is incorrect',
    RTB_PARTNER_NAME_DUPLICATED: 'RTB Partner Name already exists',
    RTB_PARTNER_ENDPOINT_ERROR: 'Endpoint is not valid',

    // PUBLISHER's PART
    ALL_INVENTORY: 'All Inventory',
    INVENTORY_BY_DAY: 'Inventory by Day',
    INVENTORY_BY_DOMAIN: 'Inventory by Domain',
    INVENTORY_BY_SUBID: 'Inventory by SubID',
    INVENTORY_ID: 'Inventory ID',
    INVENTORY_NAME: 'Inventory Name',
    INVENTORY_TYPE: 'Inventory Type',
    REGULAR: 'Regular',
    INSTREAM: 'Instream',
    OUTSTREAM: 'Outstream',
    HB: 'Header Bidding',
    HB_: 'HB',
    REPORT_MEASURES: 'Report Measures',
    OPP_REVENUE: 'Opportunities & Revenue',
    IMP_REVENUE: 'Impressions & Revenue',
    IMP_OPP_REVENUE: 'Opportunities & Revenue, Impressions & Revenue',
    DISABLED_BECAUSE_OF_PUBLISHER_IO: "It's necessary enable Publisher IO for network before",
    MRSS_URL: 'MRSS URL',
    MRSS_URL_PLACEHOLDER: 'Optional Link to MRSS',
    SERVING_DOMAIN: 'Serving Domain',
    UNIT_FORMAT: 'Unit Format',
    START_PERSISTENT: 'Start Persistent',
    THEME_COLOR: 'Theme Color',
    THEME_COLOR_LIGHT: 'Theme Color Light',
    BRAND_IMAGE_URL: 'Brand Image URL',
    BRAND_CLICK_URL: 'Brand Click URL',
    LANGUAGE: 'Language',
    INJECT_CSS: 'Inject CSS',
    VIEW_CSS_EXAMLES: 'View CSS examples',
    UNIT_VERSION: 'Unit Version',
    ADMIN_ONLY: 'Admin Only',
    ADVANCED_TAG_OPTIONS: 'Advanced Tag Options',
    CLICK_TO_EDIT_TEMPLATE: 'Click To Edit Template Code',
    RESET_TEMPLATE: 'Reset Template Code To Default',
    SHOW_THUMBNAILS: 'Show Thumbnails',
    SYNC_TAG_CODE: 'Sync Tag Code With Config',
    RESET_TO_DEFAULTS: 'Reset To Defaults',
    TAG_OUT_OF_SYNC_MESSAGE: 'Please contact customer support to enable you to edit the below parameters.',
    TAG_OUT_OF_SYNC_ADMIN_MESSAGE: 'The live tag is not synced. Perform sync to re-enable tag config changes.',
    TAG_CONFIG_MISSING_ADMIN_MESSAGE: 'This tag is old. Reset to defaults in order to allow tag config changes.',
    ENABLE_VIDEO_COMPOSER: 'Video Composer',
    Z_EVENT_LISTENER: 'Event Listener Global Name',
    Z_EVENT_LISTENER_MATCH: 'Event Types',
    BOOST_DEMAND: 'Boost Demand',
    WHITE_OPS: 'WhiteOps',
    REPORT_OMSDK_VIEWABILITY: 'Report Demand Viewability',
    TAM_PRICE_POINTS: 'TAM Price Points',
    TAM_PRICE_POINTS_COMMENT: (fileSize) =>
      `Max ${fileSize}MB .csv file (UTF-8 encoded); One item per line; 2 rows (cpm, code) without header`,
    DISABLE_VPAID: 'Disable VPAID',
    DISABLE_VPAID_TOOLTIP: 'If enabled, VPAID creatives will not be served',
    PREBID_STORE_URL_WITH_QUERIES: 'Send Prebid Store URL with queries',
    EXCLUDE_MA: 'Exclude from Multi-Auction',
    EXCLUDE_MA_TOOLTIP: 'If enabled, the demand will be exclued from Multi-Auction',
    GAP_IN_SLOT_TOOLTIP: 'If configured, prevents "back-to-back" ads playing in slot',
  },
};
